/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminRemakeNoteSearchResponse,
  AffiliateAccount,
  AffiliateApplicationInput,
  AffiliateApplicationSubmission,
  AffiliateAttributionInput,
  AffiliateAttributionResponse,
  AffiliatePayout,
  AffiliatePayoutDetailsResponse,
  AffiliatePayoutDetailsUpdate,
  AffiliateSalesResponse,
  AffiliateUsernameInput,
  CustomerDashboard,
  CustomerLogoutResponse,
  CustomerNotificationSettings,
  CustomerNotificationSettingsUpdate,
  CustomerOtpRequestInput,
  CustomerOtpRequestResponse,
  CustomerOtpVerifyInput,
  CustomerOtpVerifyResponse,
  CustomerProfile,
  DisconnectGoogleAnalytics200,
  DisconnectGoogleBusinessProfile200,
  GetGoogleAnalyticsInsightsReportParams,
  GetShopifyProductsPageParams,
  GoogleAnalyticsConnectResponse,
  GoogleAnalyticsInsightsReport,
  GoogleAnalyticsProperty,
  GoogleAnalyticsPropertySelectionInput,
  GoogleAnalyticsStatus,
  GoogleBusinessProfileConnectResponse,
  GoogleBusinessProfileLocationSelection,
  GoogleBusinessProfileLocationUpdate,
  GoogleBusinessProfileStatus,
  GoogleBusinessProfileSyncResponse,
  GoogleReviewSettings,
  GoogleReviewSettingsUpdate,
  GoogleReviewsResponse,
  GoogleSearchConsoleSite,
  GoogleSearchConsoleSiteSelectionInput,
  HealthStatus,
  ListShopifyProductsParams,
  ModerateReviewInput,
  OwnerAccount,
  OwnerAccountList,
  OwnerAccountLoginInput,
  OwnerAccountPasswordChangeResponse,
  OwnerAccountPasswordUpdate,
  OwnerAccountProfileUpdate,
  OwnerAccountSession,
  OwnerAffiliate,
  OwnerAffiliateApplication,
  OwnerAffiliateApplicationApprovalInput,
  OwnerAffiliateApplicationNotificationInput,
  OwnerAffiliateApplicationNotificationResult,
  OwnerAffiliateCommissionDefault,
  OwnerAffiliateCommissionDefaultInput,
  OwnerAffiliateCreate,
  OwnerAffiliateCreationResult,
  OwnerAffiliatePayout,
  OwnerAffiliatePayoutUpdate,
  OwnerAffiliateSale,
  OwnerAffiliateSaleHold,
  OwnerAffiliateUpdate,
  OwnerMarketingAudience,
  OwnerMarketingCampaign,
  OwnerMarketingCampaignCreate,
  OwnerMarketingCampaignList,
  OwnerMarketingCampaignSendInput,
  OwnerMarketingCampaignSendResult,
  OwnerMarketingWhatsAppTemplate,
  OwnerMarketingWhatsAppTemplateInput,
  OwnerPasswordResetCompletion,
  OwnerPasswordResetRequest,
  OwnerPasswordResetRequestResponse,
  OwnerPasswordResetVerification,
  OwnerPasswordResetVerificationResult,
  OwnerPushDeviceRegistration,
  OwnerPushDeviceRemoval,
  OwnerPushDeviceStatus,
  OwnerRemakeAlertSettings,
  OwnerRemakeAlertSettingsInput,
  OwnerReview,
  OwnerReviewsResponse,
  OwnerSessionStatus,
  OwnerStaffAccountInput,
  OwnerStaffAccountUpdate,
  PriceGateLeadInput,
  PriceGateLeadOwner,
  PriceGateLeadResponse,
  ProductEngagementResponse,
  ProductReviewsResponse,
  ProductViewInput,
  RemakeAdvancePaymentTestInput,
  RemakeAdvancePaymentTestResponse,
  RemakeNote,
  RemakeNoteInput,
  RemakeNotePhotoUploadCleanupInput,
  RemakeNotePhotoUploadInput,
  RemakeNotePhotoUploadResponse,
  RemakeRequest,
  RemakeRequestActivity,
  RemakeRequestBoardOrder,
  RemakeRequestBoardOrderUpdate,
  RemakeRequestCreated,
  RemakeRequestInput,
  RemakeRequestOwner,
  RemakeRequestUpdate,
  RemakeShippingAddressInput,
  RemakeWhatsAppDeliveryStatus,
  RemakeWhatsAppResendResponse,
  ResendRemakeWhatsAppNotificationInput,
  ReviewInvitation,
  ReviewInvitationSyncResponse,
  ReviewSettings,
  ReviewSettingsUpdate,
  ReviewSubmissionInput,
  ReviewSubmissionResponse,
  ReviewUploadRequest,
  ReviewUploadResponse,
  SearchRemakeAdminNotesParams,
  ShopifyCart,
  ShopifyCartCheckoutContactInput,
  ShopifyCartCheckoutContactResponse,
  ShopifyCartLineInput,
  ShopifyCartLineUpdate,
  ShopifyLanguageCode,
  ShopifyProduct,
  ShopifyProductTranslationsResponse,
  ShopifyProductsPage,
  ShopifyStorefrontCountry,
  ShopifyStorefrontLanguage
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetDiscoverySitemapUrl = () => {




  return `/api/discovery/sitemap.xml`
}

/**
 * Returns storefront and public Shopify product URLs for search crawlers.
 * @summary Get the public XML sitemap
 */
export const getDiscoverySitemap = async ( options?: Parameters<typeof customFetch>[1]): Promise<string> => {

  return customFetch<string>(getGetDiscoverySitemapUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDiscoverySitemapQueryKey = () => {
    return [
    `/api/discovery/sitemap.xml`
    ] as const;
    }


export const getGetDiscoverySitemapQueryOptions = <TData = Awaited<ReturnType<typeof getDiscoverySitemap>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDiscoverySitemap>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDiscoverySitemapQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDiscoverySitemap>>> = ({ signal }) => getDiscoverySitemap({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDiscoverySitemap>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDiscoverySitemapQueryResult = NonNullable<Awaited<ReturnType<typeof getDiscoverySitemap>>>
export type GetDiscoverySitemapQueryError = ErrorType<void>


/**
 * @summary Get the public XML sitemap
 */

export function useGetDiscoverySitemap<TData = Awaited<ReturnType<typeof getDiscoverySitemap>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDiscoverySitemap>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDiscoverySitemapQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetDiscoveryProductFeedUrl = () => {




  return `/api/discovery/products.xml`
}

/**
 * Returns purchasable, visible-price Shopify variants in Google RSS format.
 * @summary Get the Google Merchant product feed
 */
export const getDiscoveryProductFeed = async ( options?: Parameters<typeof customFetch>[1]): Promise<string> => {

  return customFetch<string>(getGetDiscoveryProductFeedUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDiscoveryProductFeedQueryKey = () => {
    return [
    `/api/discovery/products.xml`
    ] as const;
    }


export const getGetDiscoveryProductFeedQueryOptions = <TData = Awaited<ReturnType<typeof getDiscoveryProductFeed>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDiscoveryProductFeed>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDiscoveryProductFeedQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDiscoveryProductFeed>>> = ({ signal }) => getDiscoveryProductFeed({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDiscoveryProductFeed>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDiscoveryProductFeedQueryResult = NonNullable<Awaited<ReturnType<typeof getDiscoveryProductFeed>>>
export type GetDiscoveryProductFeedQueryError = ErrorType<void>


/**
 * @summary Get the Google Merchant product feed
 */

export function useGetDiscoveryProductFeed<TData = Awaited<ReturnType<typeof getDiscoveryProductFeed>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDiscoveryProductFeed>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDiscoveryProductFeedQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: Parameters<typeof customFetch>[1]): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListShopifyProductsUrl = (params?: ListShopifyProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/shopify/products?${stringifiedParams}` : `/api/shopify/products`
}

/**
 * @summary List storefront products
 */
export const listShopifyProducts = async (params?: ListShopifyProductsParams, options?: Parameters<typeof customFetch>[1]): Promise<ShopifyProduct[]> => {

  return customFetch<ShopifyProduct[]>(getListShopifyProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListShopifyProductsQueryKey = (params?: ListShopifyProductsParams,) => {
    return [
    `/api/shopify/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getListShopifyProductsQueryOptions = <TData = Awaited<ReturnType<typeof listShopifyProducts>>, TError = ErrorType<unknown>>(params?: ListShopifyProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListShopifyProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listShopifyProducts>>> = ({ signal }) => listShopifyProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listShopifyProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListShopifyProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listShopifyProducts>>>
export type ListShopifyProductsQueryError = ErrorType<unknown>


/**
 * @summary List storefront products
 */

export function useListShopifyProducts<TData = Awaited<ReturnType<typeof listShopifyProducts>>, TError = ErrorType<unknown>>(
 params?: ListShopifyProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListShopifyProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListShopifyProductTranslationsUrl = () => {




  return `/api/shopify/product-translations`
}

/**
 * @summary List app-managed product translations
 */
export const listShopifyProductTranslations = async ( options?: Parameters<typeof customFetch>[1]): Promise<ShopifyProductTranslationsResponse> => {

  return customFetch<ShopifyProductTranslationsResponse>(getListShopifyProductTranslationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListShopifyProductTranslationsQueryKey = () => {
    return [
    `/api/shopify/product-translations`
    ] as const;
    }


export const getListShopifyProductTranslationsQueryOptions = <TData = Awaited<ReturnType<typeof listShopifyProductTranslations>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyProductTranslations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListShopifyProductTranslationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listShopifyProductTranslations>>> = ({ signal }) => listShopifyProductTranslations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listShopifyProductTranslations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListShopifyProductTranslationsQueryResult = NonNullable<Awaited<ReturnType<typeof listShopifyProductTranslations>>>
export type ListShopifyProductTranslationsQueryError = ErrorType<unknown>


/**
 * @summary List app-managed product translations
 */

export function useListShopifyProductTranslations<TData = Awaited<ReturnType<typeof listShopifyProductTranslations>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyProductTranslations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListShopifyProductTranslationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetShopifyLocalizationUrl = () => {




  return `/api/shopify/localization`
}

/**
 * @summary List countries and currencies enabled for this Shopify storefront
 */
export const getShopifyLocalization = async ( options?: Parameters<typeof customFetch>[1]): Promise<ShopifyStorefrontCountry[]> => {

  return customFetch<ShopifyStorefrontCountry[]>(getGetShopifyLocalizationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShopifyLocalizationQueryKey = () => {
    return [
    `/api/shopify/localization`
    ] as const;
    }


export const getGetShopifyLocalizationQueryOptions = <TData = Awaited<ReturnType<typeof getShopifyLocalization>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyLocalization>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShopifyLocalizationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShopifyLocalization>>> = ({ signal }) => getShopifyLocalization({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShopifyLocalization>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShopifyLocalizationQueryResult = NonNullable<Awaited<ReturnType<typeof getShopifyLocalization>>>
export type GetShopifyLocalizationQueryError = ErrorType<unknown>


/**
 * @summary List countries and currencies enabled for this Shopify storefront
 */

export function useGetShopifyLocalization<TData = Awaited<ReturnType<typeof getShopifyLocalization>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyLocalization>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetShopifyLocalizationQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetShopifyLocalizationLanguagesUrl = () => {




  return `/api/shopify/localization/languages`
}

/**
 * @summary List languages available in the Shopify storefront
 */
export const getShopifyLocalizationLanguages = async ( options?: Parameters<typeof customFetch>[1]): Promise<ShopifyStorefrontLanguage[]> => {

  return customFetch<ShopifyStorefrontLanguage[]>(getGetShopifyLocalizationLanguagesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShopifyLocalizationLanguagesQueryKey = () => {
    return [
    `/api/shopify/localization/languages`
    ] as const;
    }


export const getGetShopifyLocalizationLanguagesQueryOptions = <TData = Awaited<ReturnType<typeof getShopifyLocalizationLanguages>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyLocalizationLanguages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShopifyLocalizationLanguagesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShopifyLocalizationLanguages>>> = ({ signal }) => getShopifyLocalizationLanguages({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShopifyLocalizationLanguages>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShopifyLocalizationLanguagesQueryResult = NonNullable<Awaited<ReturnType<typeof getShopifyLocalizationLanguages>>>
export type GetShopifyLocalizationLanguagesQueryError = ErrorType<unknown>


/**
 * @summary List languages available in the Shopify storefront
 */

export function useGetShopifyLocalizationLanguages<TData = Awaited<ReturnType<typeof getShopifyLocalizationLanguages>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyLocalizationLanguages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetShopifyLocalizationLanguagesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetShopifyProductsPageUrl = (params?: GetShopifyProductsPageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/shopify/products/page?${stringifiedParams}` : `/api/shopify/products/page`
}

/**
 * @summary List a cursor-paginated storefront product batch
 */
export const getShopifyProductsPage = async (params?: GetShopifyProductsPageParams, options?: Parameters<typeof customFetch>[1]): Promise<ShopifyProductsPage> => {

  return customFetch<ShopifyProductsPage>(getGetShopifyProductsPageUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShopifyProductsPageQueryKey = (params?: GetShopifyProductsPageParams,) => {
    return [
    `/api/shopify/products/page`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetShopifyProductsPageQueryOptions = <TData = Awaited<ReturnType<typeof getShopifyProductsPage>>, TError = ErrorType<unknown>>(params?: GetShopifyProductsPageParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyProductsPage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShopifyProductsPageQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShopifyProductsPage>>> = ({ signal }) => getShopifyProductsPage(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShopifyProductsPage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShopifyProductsPageQueryResult = NonNullable<Awaited<ReturnType<typeof getShopifyProductsPage>>>
export type GetShopifyProductsPageQueryError = ErrorType<unknown>


/**
 * @summary List a cursor-paginated storefront product batch
 */

export function useGetShopifyProductsPage<TData = Awaited<ReturnType<typeof getShopifyProductsPage>>, TError = ErrorType<unknown>>(
 params?: GetShopifyProductsPageParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyProductsPage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetShopifyProductsPageQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRequestCustomerOtpUrl = () => {




  return `/api/customer/otp/request`
}

/**
 * @summary Request a WhatsApp verification code for the customer dashboard
 */
export const requestCustomerOtp = async (customerOtpRequestInput: CustomerOtpRequestInput, options?: Parameters<typeof customFetch>[1]): Promise<CustomerOtpRequestResponse> => {

  return customFetch<CustomerOtpRequestResponse>(getRequestCustomerOtpUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerOtpRequestInput)
  }
);}





export const getRequestCustomerOtpMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCustomerOtp>>, TError,{data: BodyType<CustomerOtpRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestCustomerOtp>>, TError,{data: BodyType<CustomerOtpRequestInput>}, TContext> => {

const mutationKey = ['requestCustomerOtp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestCustomerOtp>>, {data: BodyType<CustomerOtpRequestInput>}> = (props) => {
          const {data} = props ?? {};

          return  requestCustomerOtp(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestCustomerOtpMutationResult = NonNullable<Awaited<ReturnType<typeof requestCustomerOtp>>>
    export type RequestCustomerOtpMutationBody = BodyType<CustomerOtpRequestInput>
    export type RequestCustomerOtpMutationError = ErrorType<void>

    /**
 * @summary Request a WhatsApp verification code for the customer dashboard
 */
export const useRequestCustomerOtp = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCustomerOtp>>, TError,{data: BodyType<CustomerOtpRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestCustomerOtp>>,
        TError,
        {data: BodyType<CustomerOtpRequestInput>},
        TContext
      > => {
      return useMutation(getRequestCustomerOtpMutationOptions(options));
    }

export const getVerifyCustomerOtpUrl = () => {




  return `/api/customer/otp/verify`
}

/**
 * @summary Verify a customer WhatsApp code and start a dashboard session
 */
export const verifyCustomerOtp = async (customerOtpVerifyInput: CustomerOtpVerifyInput, options?: Parameters<typeof customFetch>[1]): Promise<CustomerOtpVerifyResponse> => {

  return customFetch<CustomerOtpVerifyResponse>(getVerifyCustomerOtpUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerOtpVerifyInput)
  }
);}





export const getVerifyCustomerOtpMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCustomerOtp>>, TError,{data: BodyType<CustomerOtpVerifyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyCustomerOtp>>, TError,{data: BodyType<CustomerOtpVerifyInput>}, TContext> => {

const mutationKey = ['verifyCustomerOtp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyCustomerOtp>>, {data: BodyType<CustomerOtpVerifyInput>}> = (props) => {
          const {data} = props ?? {};

          return  verifyCustomerOtp(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyCustomerOtpMutationResult = NonNullable<Awaited<ReturnType<typeof verifyCustomerOtp>>>
    export type VerifyCustomerOtpMutationBody = BodyType<CustomerOtpVerifyInput>
    export type VerifyCustomerOtpMutationError = ErrorType<void>

    /**
 * @summary Verify a customer WhatsApp code and start a dashboard session
 */
export const useVerifyCustomerOtp = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCustomerOtp>>, TError,{data: BodyType<CustomerOtpVerifyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyCustomerOtp>>,
        TError,
        {data: BodyType<CustomerOtpVerifyInput>},
        TContext
      > => {
      return useMutation(getVerifyCustomerOtpMutationOptions(options));
    }

export const getGetCustomerDashboardUrl = () => {




  return `/api/customer/dashboard`
}

/**
 * @summary Get the authenticated customer's orders and remake requests
 */
export const getCustomerDashboard = async ( options?: Parameters<typeof customFetch>[1]): Promise<CustomerDashboard> => {

  return customFetch<CustomerDashboard>(getGetCustomerDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerDashboardQueryKey = () => {
    return [
    `/api/customer/dashboard`
    ] as const;
    }


export const getGetCustomerDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerDashboard>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerDashboard>>> = ({ signal }) => getCustomerDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerDashboard>>>
export type GetCustomerDashboardQueryError = ErrorType<void>


/**
 * @summary Get the authenticated customer's orders and remake requests
 */

export function useGetCustomerDashboard<TData = Awaited<ReturnType<typeof getCustomerDashboard>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCustomerProfileUrl = () => {




  return `/api/customer/profile`
}

/**
 * Returns read-only details derived from the verified customer session and associated remake or order records.
 * @summary Get the authenticated customer's contact and delivery details
 */
export const getCustomerProfile = async ( options?: Parameters<typeof customFetch>[1]): Promise<CustomerProfile> => {

  return customFetch<CustomerProfile>(getGetCustomerProfileUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerProfileQueryKey = () => {
    return [
    `/api/customer/profile`
    ] as const;
    }


export const getGetCustomerProfileQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerProfile>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerProfileQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerProfile>>> = ({ signal }) => getCustomerProfile({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerProfile>>>
export type GetCustomerProfileQueryError = ErrorType<void>


/**
 * @summary Get the authenticated customer's contact and delivery details
 */

export function useGetCustomerProfile<TData = Awaited<ReturnType<typeof getCustomerProfile>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerProfileQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateCustomerNotificationSettingsUrl = () => {




  return `/api/customer/notification-settings`
}

/**
 * @summary Update the authenticated customer's remake email notifications
 */
export const updateCustomerNotificationSettings = async (customerNotificationSettingsUpdate: CustomerNotificationSettingsUpdate, options?: Parameters<typeof customFetch>[1]): Promise<CustomerNotificationSettings> => {

  return customFetch<CustomerNotificationSettings>(getUpdateCustomerNotificationSettingsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerNotificationSettingsUpdate)
  }
);}





export const getUpdateCustomerNotificationSettingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomerNotificationSettings>>, TError,{data: BodyType<CustomerNotificationSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCustomerNotificationSettings>>, TError,{data: BodyType<CustomerNotificationSettingsUpdate>}, TContext> => {

const mutationKey = ['updateCustomerNotificationSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCustomerNotificationSettings>>, {data: BodyType<CustomerNotificationSettingsUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateCustomerNotificationSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomerNotificationSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateCustomerNotificationSettings>>>
    export type UpdateCustomerNotificationSettingsMutationBody = BodyType<CustomerNotificationSettingsUpdate>
    export type UpdateCustomerNotificationSettingsMutationError = ErrorType<void>

    /**
 * @summary Update the authenticated customer's remake email notifications
 */
export const useUpdateCustomerNotificationSettings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomerNotificationSettings>>, TError,{data: BodyType<CustomerNotificationSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCustomerNotificationSettings>>,
        TError,
        {data: BodyType<CustomerNotificationSettingsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateCustomerNotificationSettingsMutationOptions(options));
    }

export const getLogoutCustomerUrl = () => {




  return `/api/customer/logout`
}

/**
 * @summary End the current customer dashboard session
 */
export const logoutCustomer = async ( options?: Parameters<typeof customFetch>[1]): Promise<CustomerLogoutResponse> => {

  return customFetch<CustomerLogoutResponse>(getLogoutCustomerUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLogoutCustomerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutCustomer>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logoutCustomer>>, TError,void, TContext> => {

const mutationKey = ['logoutCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutCustomer>>, void> = () => {


          return  logoutCustomer(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof logoutCustomer>>>

    export type LogoutCustomerMutationError = ErrorType<unknown>

    /**
 * @summary End the current customer dashboard session
 */
export const useLogoutCustomer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutCustomer>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof logoutCustomer>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutCustomerMutationOptions(options));
    }

export const getGetOwnerSessionStatusUrl = () => {




  return `/api/owner/session`
}

/**
 * @summary Check the current owner session
 */
export const getOwnerSessionStatus = async ( options?: Parameters<typeof customFetch>[1]): Promise<OwnerSessionStatus> => {

  return customFetch<OwnerSessionStatus>(getGetOwnerSessionStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOwnerSessionStatusQueryKey = () => {
    return [
    `/api/owner/session`
    ] as const;
    }


export const getGetOwnerSessionStatusQueryOptions = <TData = Awaited<ReturnType<typeof getOwnerSessionStatus>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOwnerSessionStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnerSessionStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwnerSessionStatus>>> = ({ signal }) => getOwnerSessionStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOwnerSessionStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOwnerSessionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getOwnerSessionStatus>>>
export type GetOwnerSessionStatusQueryError = ErrorType<unknown>


/**
 * @summary Check the current owner session
 */

export function useGetOwnerSessionStatus<TData = Awaited<ReturnType<typeof getOwnerSessionStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOwnerSessionStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOwnerSessionStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteOwnerSessionUrl = () => {




  return `/api/owner/session`
}

/**
 * @summary End the current owner session
 */
export const deleteOwnerSession = async ( options?: Parameters<typeof customFetch>[1]): Promise<OwnerSessionStatus> => {

  return customFetch<OwnerSessionStatus>(getDeleteOwnerSessionUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteOwnerSessionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOwnerSession>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOwnerSession>>, TError,void, TContext> => {

const mutationKey = ['deleteOwnerSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOwnerSession>>, void> = () => {


          return  deleteOwnerSession(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOwnerSessionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOwnerSession>>>

    export type DeleteOwnerSessionMutationError = ErrorType<unknown>

    /**
 * @summary End the current owner session
 */
export const useDeleteOwnerSession = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOwnerSession>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteOwnerSession>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteOwnerSessionMutationOptions(options));
    }

export const getCreateOwnerAccountLoginUrl = () => {




  return `/api/owner/account-login`
}

/**
 * @summary Sign in with an owner username and password
 */
export const createOwnerAccountLogin = async (ownerAccountLoginInput: OwnerAccountLoginInput, options?: Parameters<typeof customFetch>[1]): Promise<OwnerAccountSession> => {

  return customFetch<OwnerAccountSession>(getCreateOwnerAccountLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerAccountLoginInput)
  }
);}





export const getCreateOwnerAccountLoginMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOwnerAccountLogin>>, TError,{data: BodyType<OwnerAccountLoginInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOwnerAccountLogin>>, TError,{data: BodyType<OwnerAccountLoginInput>}, TContext> => {

const mutationKey = ['createOwnerAccountLogin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOwnerAccountLogin>>, {data: BodyType<OwnerAccountLoginInput>}> = (props) => {
          const {data} = props ?? {};

          return  createOwnerAccountLogin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOwnerAccountLoginMutationResult = NonNullable<Awaited<ReturnType<typeof createOwnerAccountLogin>>>
    export type CreateOwnerAccountLoginMutationBody = BodyType<OwnerAccountLoginInput>
    export type CreateOwnerAccountLoginMutationError = ErrorType<void>

    /**
 * @summary Sign in with an owner username and password
 */
export const useCreateOwnerAccountLogin = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOwnerAccountLogin>>, TError,{data: BodyType<OwnerAccountLoginInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOwnerAccountLogin>>,
        TError,
        {data: BodyType<OwnerAccountLoginInput>},
        TContext
      > => {
      return useMutation(getCreateOwnerAccountLoginMutationOptions(options));
    }

export const getGetOwnerAccountProfileUrl = () => {




  return `/api/owner/account/profile`
}

/**
 * @summary Get the signed-in owner's account profile
 */
export const getOwnerAccountProfile = async ( options?: Parameters<typeof customFetch>[1]): Promise<OwnerAccount> => {

  return customFetch<OwnerAccount>(getGetOwnerAccountProfileUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOwnerAccountProfileQueryKey = () => {
    return [
    `/api/owner/account/profile`
    ] as const;
    }


export const getGetOwnerAccountProfileQueryOptions = <TData = Awaited<ReturnType<typeof getOwnerAccountProfile>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOwnerAccountProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnerAccountProfileQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwnerAccountProfile>>> = ({ signal }) => getOwnerAccountProfile({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOwnerAccountProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOwnerAccountProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getOwnerAccountProfile>>>
export type GetOwnerAccountProfileQueryError = ErrorType<void>


/**
 * @summary Get the signed-in owner's account profile
 */

export function useGetOwnerAccountProfile<TData = Awaited<ReturnType<typeof getOwnerAccountProfile>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOwnerAccountProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOwnerAccountProfileQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateOwnerAccountProfileUrl = () => {




  return `/api/owner/account/profile`
}

/**
 * @summary Update the signed-in owner's username
 */
export const updateOwnerAccountProfile = async (ownerAccountProfileUpdate: OwnerAccountProfileUpdate, options?: Parameters<typeof customFetch>[1]): Promise<OwnerAccount> => {

  return customFetch<OwnerAccount>(getUpdateOwnerAccountProfileUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerAccountProfileUpdate)
  }
);}





export const getUpdateOwnerAccountProfileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAccountProfile>>, TError,{data: BodyType<OwnerAccountProfileUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAccountProfile>>, TError,{data: BodyType<OwnerAccountProfileUpdate>}, TContext> => {

const mutationKey = ['updateOwnerAccountProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOwnerAccountProfile>>, {data: BodyType<OwnerAccountProfileUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateOwnerAccountProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOwnerAccountProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateOwnerAccountProfile>>>
    export type UpdateOwnerAccountProfileMutationBody = BodyType<OwnerAccountProfileUpdate>
    export type UpdateOwnerAccountProfileMutationError = ErrorType<void>

    /**
 * @summary Update the signed-in owner's username
 */
export const useUpdateOwnerAccountProfile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAccountProfile>>, TError,{data: BodyType<OwnerAccountProfileUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOwnerAccountProfile>>,
        TError,
        {data: BodyType<OwnerAccountProfileUpdate>},
        TContext
      > => {
      return useMutation(getUpdateOwnerAccountProfileMutationOptions(options));
    }

export const getUpdateOwnerAccountPasswordUrl = () => {




  return `/api/owner/account/password`
}

/**
 * @summary Change the signed-in owner's password
 */
export const updateOwnerAccountPassword = async (ownerAccountPasswordUpdate: OwnerAccountPasswordUpdate, options?: Parameters<typeof customFetch>[1]): Promise<OwnerAccountPasswordChangeResponse> => {

  return customFetch<OwnerAccountPasswordChangeResponse>(getUpdateOwnerAccountPasswordUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerAccountPasswordUpdate)
  }
);}





export const getUpdateOwnerAccountPasswordMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAccountPassword>>, TError,{data: BodyType<OwnerAccountPasswordUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAccountPassword>>, TError,{data: BodyType<OwnerAccountPasswordUpdate>}, TContext> => {

const mutationKey = ['updateOwnerAccountPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOwnerAccountPassword>>, {data: BodyType<OwnerAccountPasswordUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateOwnerAccountPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOwnerAccountPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof updateOwnerAccountPassword>>>
    export type UpdateOwnerAccountPasswordMutationBody = BodyType<OwnerAccountPasswordUpdate>
    export type UpdateOwnerAccountPasswordMutationError = ErrorType<void>

    /**
 * @summary Change the signed-in owner's password
 */
export const useUpdateOwnerAccountPassword = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAccountPassword>>, TError,{data: BodyType<OwnerAccountPasswordUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOwnerAccountPassword>>,
        TError,
        {data: BodyType<OwnerAccountPasswordUpdate>},
        TContext
      > => {
      return useMutation(getUpdateOwnerAccountPasswordMutationOptions(options));
    }

export const getRequestOwnerPasswordResetUrl = () => {




  return `/api/owner/password-reset/request`
}

/**
 * @summary Send a password recovery code to the account's WhatsApp number
 */
export const requestOwnerPasswordReset = async (ownerPasswordResetRequest: OwnerPasswordResetRequest, options?: Parameters<typeof customFetch>[1]): Promise<OwnerPasswordResetRequestResponse> => {

  return customFetch<OwnerPasswordResetRequestResponse>(getRequestOwnerPasswordResetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerPasswordResetRequest)
  }
);}





export const getRequestOwnerPasswordResetMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestOwnerPasswordReset>>, TError,{data: BodyType<OwnerPasswordResetRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestOwnerPasswordReset>>, TError,{data: BodyType<OwnerPasswordResetRequest>}, TContext> => {

const mutationKey = ['requestOwnerPasswordReset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestOwnerPasswordReset>>, {data: BodyType<OwnerPasswordResetRequest>}> = (props) => {
          const {data} = props ?? {};

          return  requestOwnerPasswordReset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestOwnerPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof requestOwnerPasswordReset>>>
    export type RequestOwnerPasswordResetMutationBody = BodyType<OwnerPasswordResetRequest>
    export type RequestOwnerPasswordResetMutationError = ErrorType<void>

    /**
 * @summary Send a password recovery code to the account's WhatsApp number
 */
export const useRequestOwnerPasswordReset = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestOwnerPasswordReset>>, TError,{data: BodyType<OwnerPasswordResetRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestOwnerPasswordReset>>,
        TError,
        {data: BodyType<OwnerPasswordResetRequest>},
        TContext
      > => {
      return useMutation(getRequestOwnerPasswordResetMutationOptions(options));
    }

export const getVerifyOwnerPasswordResetCodeUrl = () => {




  return `/api/owner/password-reset/verify`
}

/**
 * @summary Verify an owner WhatsApp recovery code
 */
export const verifyOwnerPasswordResetCode = async (ownerPasswordResetVerification: OwnerPasswordResetVerification, options?: Parameters<typeof customFetch>[1]): Promise<OwnerPasswordResetVerificationResult> => {

  return customFetch<OwnerPasswordResetVerificationResult>(getVerifyOwnerPasswordResetCodeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerPasswordResetVerification)
  }
);}





export const getVerifyOwnerPasswordResetCodeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyOwnerPasswordResetCode>>, TError,{data: BodyType<OwnerPasswordResetVerification>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyOwnerPasswordResetCode>>, TError,{data: BodyType<OwnerPasswordResetVerification>}, TContext> => {

const mutationKey = ['verifyOwnerPasswordResetCode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyOwnerPasswordResetCode>>, {data: BodyType<OwnerPasswordResetVerification>}> = (props) => {
          const {data} = props ?? {};

          return  verifyOwnerPasswordResetCode(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyOwnerPasswordResetCodeMutationResult = NonNullable<Awaited<ReturnType<typeof verifyOwnerPasswordResetCode>>>
    export type VerifyOwnerPasswordResetCodeMutationBody = BodyType<OwnerPasswordResetVerification>
    export type VerifyOwnerPasswordResetCodeMutationError = ErrorType<void>

    /**
 * @summary Verify an owner WhatsApp recovery code
 */
export const useVerifyOwnerPasswordResetCode = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyOwnerPasswordResetCode>>, TError,{data: BodyType<OwnerPasswordResetVerification>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyOwnerPasswordResetCode>>,
        TError,
        {data: BodyType<OwnerPasswordResetVerification>},
        TContext
      > => {
      return useMutation(getVerifyOwnerPasswordResetCodeMutationOptions(options));
    }

export const getCompleteOwnerPasswordResetUrl = () => {




  return `/api/owner/password-reset/complete`
}

/**
 * @summary Set a new password after verifying the recovery code
 */
export const completeOwnerPasswordReset = async (ownerPasswordResetCompletion: OwnerPasswordResetCompletion, options?: Parameters<typeof customFetch>[1]): Promise<OwnerAccountSession> => {

  return customFetch<OwnerAccountSession>(getCompleteOwnerPasswordResetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerPasswordResetCompletion)
  }
);}





export const getCompleteOwnerPasswordResetMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeOwnerPasswordReset>>, TError,{data: BodyType<OwnerPasswordResetCompletion>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof completeOwnerPasswordReset>>, TError,{data: BodyType<OwnerPasswordResetCompletion>}, TContext> => {

const mutationKey = ['completeOwnerPasswordReset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeOwnerPasswordReset>>, {data: BodyType<OwnerPasswordResetCompletion>}> = (props) => {
          const {data} = props ?? {};

          return  completeOwnerPasswordReset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteOwnerPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof completeOwnerPasswordReset>>>
    export type CompleteOwnerPasswordResetMutationBody = BodyType<OwnerPasswordResetCompletion>
    export type CompleteOwnerPasswordResetMutationError = ErrorType<void>

    /**
 * @summary Set a new password after verifying the recovery code
 */
export const useCompleteOwnerPasswordReset = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeOwnerPasswordReset>>, TError,{data: BodyType<OwnerPasswordResetCompletion>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof completeOwnerPasswordReset>>,
        TError,
        {data: BodyType<OwnerPasswordResetCompletion>},
        TContext
      > => {
      return useMutation(getCompleteOwnerPasswordResetMutationOptions(options));
    }

export const getListOwnerAccountsUrl = () => {




  return `/api/owner/accounts`
}

/**
 * @summary List owner and staff accounts for administrators
 */
export const listOwnerAccounts = async ( options?: Parameters<typeof customFetch>[1]): Promise<OwnerAccountList> => {

  return customFetch<OwnerAccountList>(getListOwnerAccountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOwnerAccountsQueryKey = () => {
    return [
    `/api/owner/accounts`
    ] as const;
    }


export const getListOwnerAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listOwnerAccounts>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOwnerAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOwnerAccountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOwnerAccounts>>> = ({ signal }) => listOwnerAccounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOwnerAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOwnerAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listOwnerAccounts>>>
export type ListOwnerAccountsQueryError = ErrorType<void>


/**
 * @summary List owner and staff accounts for administrators
 */

export function useListOwnerAccounts<TData = Awaited<ReturnType<typeof listOwnerAccounts>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOwnerAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOwnerAccountsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateOwnerAccountUrl = () => {




  return `/api/owner/accounts`
}

/**
 * @summary Create a staff account for administrators
 */
export const createOwnerAccount = async (ownerStaffAccountInput: OwnerStaffAccountInput, options?: Parameters<typeof customFetch>[1]): Promise<OwnerAccount> => {

  return customFetch<OwnerAccount>(getCreateOwnerAccountUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerStaffAccountInput)
  }
);}





export const getCreateOwnerAccountMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOwnerAccount>>, TError,{data: BodyType<OwnerStaffAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOwnerAccount>>, TError,{data: BodyType<OwnerStaffAccountInput>}, TContext> => {

const mutationKey = ['createOwnerAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOwnerAccount>>, {data: BodyType<OwnerStaffAccountInput>}> = (props) => {
          const {data} = props ?? {};

          return  createOwnerAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOwnerAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createOwnerAccount>>>
    export type CreateOwnerAccountMutationBody = BodyType<OwnerStaffAccountInput>
    export type CreateOwnerAccountMutationError = ErrorType<void>

    /**
 * @summary Create a staff account for administrators
 */
export const useCreateOwnerAccount = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOwnerAccount>>, TError,{data: BodyType<OwnerStaffAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOwnerAccount>>,
        TError,
        {data: BodyType<OwnerStaffAccountInput>},
        TContext
      > => {
      return useMutation(getCreateOwnerAccountMutationOptions(options));
    }

export const getUpdateOwnerAccountUrl = (accountId: string,) => {




  return `/api/owner/accounts/${accountId}`
}

/**
 * @summary Update staff modules or active status
 */
export const updateOwnerAccount = async (accountId: string,
    ownerStaffAccountUpdate: OwnerStaffAccountUpdate, options?: Parameters<typeof customFetch>[1]): Promise<OwnerAccount> => {

  return customFetch<OwnerAccount>(getUpdateOwnerAccountUrl(accountId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerStaffAccountUpdate)
  }
);}





export const getUpdateOwnerAccountMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAccount>>, TError,{accountId: string;data: BodyType<OwnerStaffAccountUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAccount>>, TError,{accountId: string;data: BodyType<OwnerStaffAccountUpdate>}, TContext> => {

const mutationKey = ['updateOwnerAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOwnerAccount>>, {accountId: string;data: BodyType<OwnerStaffAccountUpdate>}> = (props) => {
          const {accountId,data} = props ?? {};

          return  updateOwnerAccount(accountId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOwnerAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateOwnerAccount>>>
    export type UpdateOwnerAccountMutationBody = BodyType<OwnerStaffAccountUpdate>
    export type UpdateOwnerAccountMutationError = ErrorType<void>

    /**
 * @summary Update staff modules or active status
 */
export const useUpdateOwnerAccount = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAccount>>, TError,{accountId: string;data: BodyType<OwnerStaffAccountUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOwnerAccount>>,
        TError,
        {accountId: string;data: BodyType<OwnerStaffAccountUpdate>},
        TContext
      > => {
      return useMutation(getUpdateOwnerAccountMutationOptions(options));
    }

export const getRegisterOwnerPushDeviceUrl = () => {




  return `/api/owner/push-devices`
}

/**
 * @summary Register a signed-in owner's mobile push device
 */
export const registerOwnerPushDevice = async (ownerPushDeviceRegistration: OwnerPushDeviceRegistration, options?: Parameters<typeof customFetch>[1]): Promise<OwnerPushDeviceStatus> => {

  return customFetch<OwnerPushDeviceStatus>(getRegisterOwnerPushDeviceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerPushDeviceRegistration)
  }
);}





export const getRegisterOwnerPushDeviceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerOwnerPushDevice>>, TError,{data: BodyType<OwnerPushDeviceRegistration>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof registerOwnerPushDevice>>, TError,{data: BodyType<OwnerPushDeviceRegistration>}, TContext> => {

const mutationKey = ['registerOwnerPushDevice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerOwnerPushDevice>>, {data: BodyType<OwnerPushDeviceRegistration>}> = (props) => {
          const {data} = props ?? {};

          return  registerOwnerPushDevice(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterOwnerPushDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof registerOwnerPushDevice>>>
    export type RegisterOwnerPushDeviceMutationBody = BodyType<OwnerPushDeviceRegistration>
    export type RegisterOwnerPushDeviceMutationError = ErrorType<void>

    /**
 * @summary Register a signed-in owner's mobile push device
 */
export const useRegisterOwnerPushDevice = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerOwnerPushDevice>>, TError,{data: BodyType<OwnerPushDeviceRegistration>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof registerOwnerPushDevice>>,
        TError,
        {data: BodyType<OwnerPushDeviceRegistration>},
        TContext
      > => {
      return useMutation(getRegisterOwnerPushDeviceMutationOptions(options));
    }

export const getUnregisterOwnerPushDeviceUrl = () => {




  return `/api/owner/push-devices`
}

/**
 * @summary Unregister a signed-in owner's mobile push device
 */
export const unregisterOwnerPushDevice = async (ownerPushDeviceRemoval: OwnerPushDeviceRemoval, options?: Parameters<typeof customFetch>[1]): Promise<OwnerPushDeviceStatus> => {

  return customFetch<OwnerPushDeviceStatus>(getUnregisterOwnerPushDeviceUrl(),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerPushDeviceRemoval)
  }
);}





export const getUnregisterOwnerPushDeviceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unregisterOwnerPushDevice>>, TError,{data: BodyType<OwnerPushDeviceRemoval>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unregisterOwnerPushDevice>>, TError,{data: BodyType<OwnerPushDeviceRemoval>}, TContext> => {

const mutationKey = ['unregisterOwnerPushDevice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unregisterOwnerPushDevice>>, {data: BodyType<OwnerPushDeviceRemoval>}> = (props) => {
          const {data} = props ?? {};

          return  unregisterOwnerPushDevice(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnregisterOwnerPushDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof unregisterOwnerPushDevice>>>
    export type UnregisterOwnerPushDeviceMutationBody = BodyType<OwnerPushDeviceRemoval>
    export type UnregisterOwnerPushDeviceMutationError = ErrorType<void>

    /**
 * @summary Unregister a signed-in owner's mobile push device
 */
export const useUnregisterOwnerPushDevice = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unregisterOwnerPushDevice>>, TError,{data: BodyType<OwnerPushDeviceRemoval>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unregisterOwnerPushDevice>>,
        TError,
        {data: BodyType<OwnerPushDeviceRemoval>},
        TContext
      > => {
      return useMutation(getUnregisterOwnerPushDeviceMutationOptions(options));
    }

export const getCreateRemakeRequestUrl = () => {




  return `/api/shopify/remake-requests`
}

/**
 * Saves a lightweight remake request. Delivery details are collected later, when the atelier confirms a quote.
 * @summary Request a remake of a sold-out piece
 */
export const createRemakeRequest = async (remakeRequestInput: RemakeRequestInput, options?: Parameters<typeof customFetch>[1]): Promise<RemakeRequestCreated> => {

  return customFetch<RemakeRequestCreated>(getCreateRemakeRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remakeRequestInput)
  }
);}





export const getCreateRemakeRequestMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRemakeRequest>>, TError,{data: BodyType<RemakeRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRemakeRequest>>, TError,{data: BodyType<RemakeRequestInput>}, TContext> => {

const mutationKey = ['createRemakeRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRemakeRequest>>, {data: BodyType<RemakeRequestInput>}> = (props) => {
          const {data} = props ?? {};

          return  createRemakeRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRemakeRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createRemakeRequest>>>
    export type CreateRemakeRequestMutationBody = BodyType<RemakeRequestInput>
    export type CreateRemakeRequestMutationError = ErrorType<void>

    /**
 * @summary Request a remake of a sold-out piece
 */
export const useCreateRemakeRequest = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRemakeRequest>>, TError,{data: BodyType<RemakeRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createRemakeRequest>>,
        TError,
        {data: BodyType<RemakeRequestInput>},
        TContext
      > => {
      return useMutation(getCreateRemakeRequestMutationOptions(options));
    }

export const getGetRemakeRequestUrl = (reference: string,) => {




  return `/api/shopify/remake-requests/${reference}`
}

/**
 * @summary Get the safe customer-facing status of a remake request
 */
export const getRemakeRequest = async (reference: string, options?: Parameters<typeof customFetch>[1]): Promise<RemakeRequest> => {

  return customFetch<RemakeRequest>(getGetRemakeRequestUrl(reference),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRemakeRequestQueryKey = (reference: string,) => {
    return [
    `/api/shopify/remake-requests/${reference}`
    ] as const;
    }


export const getGetRemakeRequestQueryOptions = <TData = Awaited<ReturnType<typeof getRemakeRequest>>, TError = ErrorType<void>>(reference: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRemakeRequest>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRemakeRequestQueryKey(reference);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRemakeRequest>>> = ({ signal }) => getRemakeRequest(reference, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: reference !== null && reference !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRemakeRequest>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRemakeRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getRemakeRequest>>>
export type GetRemakeRequestQueryError = ErrorType<void>


/**
 * @summary Get the safe customer-facing status of a remake request
 */

export function useGetRemakeRequest<TData = Awaited<ReturnType<typeof getRemakeRequest>>, TError = ErrorType<void>>(
 reference: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRemakeRequest>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRemakeRequestQueryOptions(reference,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateRemakeShippingUrl = (reference: string,) => {




  return `/api/shopify/remake-requests/${reference}`
}

/**
 * Customers may submit or revise the delivery address while the remake is ready and before the atelier enters a manual shipping charge. After charges are entered, only the owner may update the address.
 * @summary Add delivery details before shipping charges are entered
 */
export const updateRemakeShipping = async (reference: string,
    remakeShippingAddressInput: RemakeShippingAddressInput, options?: Parameters<typeof customFetch>[1]): Promise<RemakeRequest> => {

  return customFetch<RemakeRequest>(getUpdateRemakeShippingUrl(reference),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remakeShippingAddressInput)
  }
);}





export const getUpdateRemakeShippingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRemakeShipping>>, TError,{reference: string;data: BodyType<RemakeShippingAddressInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRemakeShipping>>, TError,{reference: string;data: BodyType<RemakeShippingAddressInput>}, TContext> => {

const mutationKey = ['updateRemakeShipping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRemakeShipping>>, {reference: string;data: BodyType<RemakeShippingAddressInput>}> = (props) => {
          const {reference,data} = props ?? {};

          return  updateRemakeShipping(reference,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRemakeShippingMutationResult = NonNullable<Awaited<ReturnType<typeof updateRemakeShipping>>>
    export type UpdateRemakeShippingMutationBody = BodyType<RemakeShippingAddressInput>
    export type UpdateRemakeShippingMutationError = ErrorType<void>

    /**
 * @summary Add delivery details before shipping charges are entered
 */
export const useUpdateRemakeShipping = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRemakeShipping>>, TError,{reference: string;data: BodyType<RemakeShippingAddressInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateRemakeShipping>>,
        TError,
        {reference: string;data: BodyType<RemakeShippingAddressInput>},
        TContext
      > => {
      return useMutation(getUpdateRemakeShippingMutationOptions(options));
    }

export const getListRemakeRequestsUrl = () => {




  return `/api/owner/remake-requests`
}

/**
 * @summary List remake requests for the store owner
 */
export const listRemakeRequests = async ( options?: Parameters<typeof customFetch>[1]): Promise<RemakeRequestOwner[]> => {

  return customFetch<RemakeRequestOwner[]>(getListRemakeRequestsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRemakeRequestsQueryKey = () => {
    return [
    `/api/owner/remake-requests`
    ] as const;
    }


export const getListRemakeRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listRemakeRequests>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRemakeRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRemakeRequestsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRemakeRequests>>> = ({ signal }) => listRemakeRequests({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRemakeRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRemakeRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listRemakeRequests>>>
export type ListRemakeRequestsQueryError = ErrorType<void>


/**
 * @summary List remake requests for the store owner
 */

export function useListRemakeRequests<TData = Awaited<ReturnType<typeof listRemakeRequests>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRemakeRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRemakeRequestsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSaveRemakeRequestBoardOrderUrl = () => {




  return `/api/owner/remake-requests/order`
}

/**
 * @summary Save the owner's manual remake board order
 */
export const saveRemakeRequestBoardOrder = async (remakeRequestBoardOrderUpdate: RemakeRequestBoardOrderUpdate, options?: Parameters<typeof customFetch>[1]): Promise<RemakeRequestBoardOrder> => {

  return customFetch<RemakeRequestBoardOrder>(getSaveRemakeRequestBoardOrderUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remakeRequestBoardOrderUpdate)
  }
);}





export const getSaveRemakeRequestBoardOrderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveRemakeRequestBoardOrder>>, TError,{data: BodyType<RemakeRequestBoardOrderUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveRemakeRequestBoardOrder>>, TError,{data: BodyType<RemakeRequestBoardOrderUpdate>}, TContext> => {

const mutationKey = ['saveRemakeRequestBoardOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveRemakeRequestBoardOrder>>, {data: BodyType<RemakeRequestBoardOrderUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  saveRemakeRequestBoardOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveRemakeRequestBoardOrderMutationResult = NonNullable<Awaited<ReturnType<typeof saveRemakeRequestBoardOrder>>>
    export type SaveRemakeRequestBoardOrderMutationBody = BodyType<RemakeRequestBoardOrderUpdate>
    export type SaveRemakeRequestBoardOrderMutationError = ErrorType<void>

    /**
 * @summary Save the owner's manual remake board order
 */
export const useSaveRemakeRequestBoardOrder = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveRemakeRequestBoardOrder>>, TError,{data: BodyType<RemakeRequestBoardOrderUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveRemakeRequestBoardOrder>>,
        TError,
        {data: BodyType<RemakeRequestBoardOrderUpdate>},
        TContext
      > => {
      return useMutation(getSaveRemakeRequestBoardOrderMutationOptions(options));
    }

export const getSearchRemakeAdminNotesUrl = (params: SearchRemakeAdminNotesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/owner/remake-requests/admin-note-search?${stringifiedParams}` : `/api/owner/remake-requests/admin-note-search`
}

/**
 * @summary Search private remake notes for the store owner
 */
export const searchRemakeAdminNotes = async (params: SearchRemakeAdminNotesParams, options?: Parameters<typeof customFetch>[1]): Promise<AdminRemakeNoteSearchResponse> => {

  return customFetch<AdminRemakeNoteSearchResponse>(getSearchRemakeAdminNotesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchRemakeAdminNotesQueryKey = (params?: SearchRemakeAdminNotesParams,) => {
    return [
    `/api/owner/remake-requests/admin-note-search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchRemakeAdminNotesQueryOptions = <TData = Awaited<ReturnType<typeof searchRemakeAdminNotes>>, TError = ErrorType<void>>(params: SearchRemakeAdminNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchRemakeAdminNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchRemakeAdminNotesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchRemakeAdminNotes>>> = ({ signal }) => searchRemakeAdminNotes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchRemakeAdminNotes>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchRemakeAdminNotesQueryResult = NonNullable<Awaited<ReturnType<typeof searchRemakeAdminNotes>>>
export type SearchRemakeAdminNotesQueryError = ErrorType<void>


/**
 * @summary Search private remake notes for the store owner
 */

export function useSearchRemakeAdminNotes<TData = Awaited<ReturnType<typeof searchRemakeAdminNotes>>, TError = ErrorType<void>>(
 params: SearchRemakeAdminNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchRemakeAdminNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSearchRemakeAdminNotesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateRemakeRequestUrl = (reference: string,) => {




  return `/api/owner/remake-requests/${reference}`
}

/**
 * @summary Confirm a quote or move a remake through production
 */
export const updateRemakeRequest = async (reference: string,
    remakeRequestUpdate: RemakeRequestUpdate, options?: Parameters<typeof customFetch>[1]): Promise<RemakeRequestOwner> => {

  return customFetch<RemakeRequestOwner>(getUpdateRemakeRequestUrl(reference),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remakeRequestUpdate)
  }
);}





export const getUpdateRemakeRequestMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRemakeRequest>>, TError,{reference: string;data: BodyType<RemakeRequestUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRemakeRequest>>, TError,{reference: string;data: BodyType<RemakeRequestUpdate>}, TContext> => {

const mutationKey = ['updateRemakeRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRemakeRequest>>, {reference: string;data: BodyType<RemakeRequestUpdate>}> = (props) => {
          const {reference,data} = props ?? {};

          return  updateRemakeRequest(reference,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRemakeRequestMutationResult = NonNullable<Awaited<ReturnType<typeof updateRemakeRequest>>>
    export type UpdateRemakeRequestMutationBody = BodyType<RemakeRequestUpdate>
    export type UpdateRemakeRequestMutationError = ErrorType<void>

    /**
 * @summary Confirm a quote or move a remake through production
 */
export const useUpdateRemakeRequest = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRemakeRequest>>, TError,{reference: string;data: BodyType<RemakeRequestUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateRemakeRequest>>,
        TError,
        {reference: string;data: BodyType<RemakeRequestUpdate>},
        TContext
      > => {
      return useMutation(getUpdateRemakeRequestMutationOptions(options));
    }

export const getCreateRemakeBalancePaymentUrl = (reference: string,) => {




  return `/api/owner/remake-requests/${reference}/balance-payment`
}

/**
 * Creates the balance payment link with delivery included; the advance link remains limited to the quoted advance amount.
 * @summary Create or reveal the hosted balance payment link
 */
export const createRemakeBalancePayment = async (reference: string, options?: Parameters<typeof customFetch>[1]): Promise<RemakeRequestOwner> => {

  return customFetch<RemakeRequestOwner>(getCreateRemakeBalancePaymentUrl(reference),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateRemakeBalancePaymentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRemakeBalancePayment>>, TError,{reference: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRemakeBalancePayment>>, TError,{reference: string}, TContext> => {

const mutationKey = ['createRemakeBalancePayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRemakeBalancePayment>>, {reference: string}> = (props) => {
          const {reference} = props ?? {};

          return  createRemakeBalancePayment(reference,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRemakeBalancePaymentMutationResult = NonNullable<Awaited<ReturnType<typeof createRemakeBalancePayment>>>

    export type CreateRemakeBalancePaymentMutationError = ErrorType<void>

    /**
 * @summary Create or reveal the hosted balance payment link
 */
export const useCreateRemakeBalancePayment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRemakeBalancePayment>>, TError,{reference: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createRemakeBalancePayment>>,
        TError,
        {reference: string},
        TContext
      > => {
      return useMutation(getCreateRemakeBalancePaymentMutationOptions(options));
    }

export const getSendRemakeAdvancePaymentTestEmailUrl = (reference: string,) => {




  return `/api/owner/remake-requests/${reference}/test-advance-email`
}

/**
 * Creates a Shopify test order with remake-payment and advance tags, then asks Shopify to send its native order confirmation using the configured Liquid template.
 * @summary Create a Shopify test order and send its native advance confirmation
 */
export const sendRemakeAdvancePaymentTestEmail = async (reference: string,
    remakeAdvancePaymentTestInput: RemakeAdvancePaymentTestInput, options?: Parameters<typeof customFetch>[1]): Promise<RemakeAdvancePaymentTestResponse> => {

  return customFetch<RemakeAdvancePaymentTestResponse>(getSendRemakeAdvancePaymentTestEmailUrl(reference),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remakeAdvancePaymentTestInput)
  }
);}





export const getSendRemakeAdvancePaymentTestEmailMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendRemakeAdvancePaymentTestEmail>>, TError,{reference: string;data: BodyType<RemakeAdvancePaymentTestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendRemakeAdvancePaymentTestEmail>>, TError,{reference: string;data: BodyType<RemakeAdvancePaymentTestInput>}, TContext> => {

const mutationKey = ['sendRemakeAdvancePaymentTestEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendRemakeAdvancePaymentTestEmail>>, {reference: string;data: BodyType<RemakeAdvancePaymentTestInput>}> = (props) => {
          const {reference,data} = props ?? {};

          return  sendRemakeAdvancePaymentTestEmail(reference,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendRemakeAdvancePaymentTestEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendRemakeAdvancePaymentTestEmail>>>
    export type SendRemakeAdvancePaymentTestEmailMutationBody = BodyType<RemakeAdvancePaymentTestInput>
    export type SendRemakeAdvancePaymentTestEmailMutationError = ErrorType<void>

    /**
 * @summary Create a Shopify test order and send its native advance confirmation
 */
export const useSendRemakeAdvancePaymentTestEmail = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendRemakeAdvancePaymentTestEmail>>, TError,{reference: string;data: BodyType<RemakeAdvancePaymentTestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendRemakeAdvancePaymentTestEmail>>,
        TError,
        {reference: string;data: BodyType<RemakeAdvancePaymentTestInput>},
        TContext
      > => {
      return useMutation(getSendRemakeAdvancePaymentTestEmailMutationOptions(options));
    }

export const getListRemakeNotesUrl = (reference: string,) => {




  return `/api/owner/remake-requests/${reference}/notes`
}

/**
 * @summary List private atelier notes for a remake
 */
export const listRemakeNotes = async (reference: string, options?: Parameters<typeof customFetch>[1]): Promise<RemakeNote[]> => {

  return customFetch<RemakeNote[]>(getListRemakeNotesUrl(reference),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRemakeNotesQueryKey = (reference: string,) => {
    return [
    `/api/owner/remake-requests/${reference}/notes`
    ] as const;
    }


export const getListRemakeNotesQueryOptions = <TData = Awaited<ReturnType<typeof listRemakeNotes>>, TError = ErrorType<void>>(reference: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRemakeNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRemakeNotesQueryKey(reference);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRemakeNotes>>> = ({ signal }) => listRemakeNotes(reference, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: reference !== null && reference !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRemakeNotes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRemakeNotesQueryResult = NonNullable<Awaited<ReturnType<typeof listRemakeNotes>>>
export type ListRemakeNotesQueryError = ErrorType<void>


/**
 * @summary List private atelier notes for a remake
 */

export function useListRemakeNotes<TData = Awaited<ReturnType<typeof listRemakeNotes>>, TError = ErrorType<void>>(
 reference: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRemakeNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRemakeNotesQueryOptions(reference,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateRemakeNoteUrl = (reference: string,) => {




  return `/api/owner/remake-requests/${reference}/notes`
}

/**
 * @summary Save a private atelier note for a remake
 */
export const createRemakeNote = async (reference: string,
    remakeNoteInput: RemakeNoteInput, options?: Parameters<typeof customFetch>[1]): Promise<RemakeNote> => {

  return customFetch<RemakeNote>(getCreateRemakeNoteUrl(reference),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remakeNoteInput)
  }
);}





export const getCreateRemakeNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRemakeNote>>, TError,{reference: string;data: BodyType<RemakeNoteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRemakeNote>>, TError,{reference: string;data: BodyType<RemakeNoteInput>}, TContext> => {

const mutationKey = ['createRemakeNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRemakeNote>>, {reference: string;data: BodyType<RemakeNoteInput>}> = (props) => {
          const {reference,data} = props ?? {};

          return  createRemakeNote(reference,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRemakeNoteMutationResult = NonNullable<Awaited<ReturnType<typeof createRemakeNote>>>
    export type CreateRemakeNoteMutationBody = BodyType<RemakeNoteInput>
    export type CreateRemakeNoteMutationError = ErrorType<void>

    /**
 * @summary Save a private atelier note for a remake
 */
export const useCreateRemakeNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRemakeNote>>, TError,{reference: string;data: BodyType<RemakeNoteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createRemakeNote>>,
        TError,
        {reference: string;data: BodyType<RemakeNoteInput>},
        TContext
      > => {
      return useMutation(getCreateRemakeNoteMutationOptions(options));
    }

export const getRequestRemakeNotePhotoUploadUrl = (reference: string,) => {




  return `/api/owner/remake-requests/${reference}/notes/photo-upload`
}

/**
 * @summary Request an owner-authenticated upload URL for a remake note photo
 */
export const requestRemakeNotePhotoUpload = async (reference: string,
    remakeNotePhotoUploadInput: RemakeNotePhotoUploadInput, options?: Parameters<typeof customFetch>[1]): Promise<RemakeNotePhotoUploadResponse> => {

  return customFetch<RemakeNotePhotoUploadResponse>(getRequestRemakeNotePhotoUploadUrl(reference),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remakeNotePhotoUploadInput)
  }
);}





export const getRequestRemakeNotePhotoUploadMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestRemakeNotePhotoUpload>>, TError,{reference: string;data: BodyType<RemakeNotePhotoUploadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestRemakeNotePhotoUpload>>, TError,{reference: string;data: BodyType<RemakeNotePhotoUploadInput>}, TContext> => {

const mutationKey = ['requestRemakeNotePhotoUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestRemakeNotePhotoUpload>>, {reference: string;data: BodyType<RemakeNotePhotoUploadInput>}> = (props) => {
          const {reference,data} = props ?? {};

          return  requestRemakeNotePhotoUpload(reference,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestRemakeNotePhotoUploadMutationResult = NonNullable<Awaited<ReturnType<typeof requestRemakeNotePhotoUpload>>>
    export type RequestRemakeNotePhotoUploadMutationBody = BodyType<RemakeNotePhotoUploadInput>
    export type RequestRemakeNotePhotoUploadMutationError = ErrorType<void>

    /**
 * @summary Request an owner-authenticated upload URL for a remake note photo
 */
export const useRequestRemakeNotePhotoUpload = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestRemakeNotePhotoUpload>>, TError,{reference: string;data: BodyType<RemakeNotePhotoUploadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestRemakeNotePhotoUpload>>,
        TError,
        {reference: string;data: BodyType<RemakeNotePhotoUploadInput>},
        TContext
      > => {
      return useMutation(getRequestRemakeNotePhotoUploadMutationOptions(options));
    }

export const getDiscardRemakeNotePhotoUploadUrl = (reference: string,) => {




  return `/api/owner/remake-requests/${reference}/notes/photo-upload`
}

/**
 * @summary Delete an unattached photo upload for a remake note
 */
export const discardRemakeNotePhotoUpload = async (reference: string,
    remakeNotePhotoUploadCleanupInput: RemakeNotePhotoUploadCleanupInput, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDiscardRemakeNotePhotoUploadUrl(reference),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remakeNotePhotoUploadCleanupInput)
  }
);}





export const getDiscardRemakeNotePhotoUploadMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discardRemakeNotePhotoUpload>>, TError,{reference: string;data: BodyType<RemakeNotePhotoUploadCleanupInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof discardRemakeNotePhotoUpload>>, TError,{reference: string;data: BodyType<RemakeNotePhotoUploadCleanupInput>}, TContext> => {

const mutationKey = ['discardRemakeNotePhotoUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discardRemakeNotePhotoUpload>>, {reference: string;data: BodyType<RemakeNotePhotoUploadCleanupInput>}> = (props) => {
          const {reference,data} = props ?? {};

          return  discardRemakeNotePhotoUpload(reference,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscardRemakeNotePhotoUploadMutationResult = NonNullable<Awaited<ReturnType<typeof discardRemakeNotePhotoUpload>>>
    export type DiscardRemakeNotePhotoUploadMutationBody = BodyType<RemakeNotePhotoUploadCleanupInput>
    export type DiscardRemakeNotePhotoUploadMutationError = ErrorType<void>

    /**
 * @summary Delete an unattached photo upload for a remake note
 */
export const useDiscardRemakeNotePhotoUpload = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discardRemakeNotePhotoUpload>>, TError,{reference: string;data: BodyType<RemakeNotePhotoUploadCleanupInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof discardRemakeNotePhotoUpload>>,
        TError,
        {reference: string;data: BodyType<RemakeNotePhotoUploadCleanupInput>},
        TContext
      > => {
      return useMutation(getDiscardRemakeNotePhotoUploadMutationOptions(options));
    }

export const getGetRemakeNotePhotoUrl = (reference: string,
    noteId: number,) => {




  return `/api/owner/remake-requests/${reference}/notes/${noteId}/photo`
}

/**
 * @summary Serve a private photo attached to an atelier note
 */
export const getRemakeNotePhoto = async (reference: string,
    noteId: number, options?: Parameters<typeof customFetch>[1]): Promise<Blob> => {

  return customFetch<Blob>(getGetRemakeNotePhotoUrl(reference,noteId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRemakeNotePhotoQueryKey = (reference: string,
    noteId: number,) => {
    return [
    `/api/owner/remake-requests/${reference}/notes/${noteId}/photo`
    ] as const;
    }


export const getGetRemakeNotePhotoQueryOptions = <TData = Awaited<ReturnType<typeof getRemakeNotePhoto>>, TError = ErrorType<void>>(reference: string,
    noteId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRemakeNotePhoto>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRemakeNotePhotoQueryKey(reference,noteId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRemakeNotePhoto>>> = ({ signal }) => getRemakeNotePhoto(reference,noteId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: reference !== null && reference !== undefined && noteId !== null && noteId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRemakeNotePhoto>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRemakeNotePhotoQueryResult = NonNullable<Awaited<ReturnType<typeof getRemakeNotePhoto>>>
export type GetRemakeNotePhotoQueryError = ErrorType<void>


/**
 * @summary Serve a private photo attached to an atelier note
 */

export function useGetRemakeNotePhoto<TData = Awaited<ReturnType<typeof getRemakeNotePhoto>>, TError = ErrorType<void>>(
 reference: string,
    noteId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRemakeNotePhoto>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRemakeNotePhotoQueryOptions(reference,noteId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetRemakeNotePhotoAttachmentUrl = (reference: string,
    noteId: number,
    photoId: number,) => {




  return `/api/owner/remake-requests/${reference}/notes/${noteId}/photos/${photoId}`
}

/**
 * @summary Serve one private photo attached to an atelier note
 */
export const getRemakeNotePhotoAttachment = async (reference: string,
    noteId: number,
    photoId: number, options?: Parameters<typeof customFetch>[1]): Promise<Blob> => {

  return customFetch<Blob>(getGetRemakeNotePhotoAttachmentUrl(reference,noteId,photoId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRemakeNotePhotoAttachmentQueryKey = (reference: string,
    noteId: number,
    photoId: number,) => {
    return [
    `/api/owner/remake-requests/${reference}/notes/${noteId}/photos/${photoId}`
    ] as const;
    }


export const getGetRemakeNotePhotoAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof getRemakeNotePhotoAttachment>>, TError = ErrorType<void>>(reference: string,
    noteId: number,
    photoId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRemakeNotePhotoAttachment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRemakeNotePhotoAttachmentQueryKey(reference,noteId,photoId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRemakeNotePhotoAttachment>>> = ({ signal }) => getRemakeNotePhotoAttachment(reference,noteId,photoId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: reference !== null && reference !== undefined && noteId !== null && noteId !== undefined && photoId !== null && photoId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRemakeNotePhotoAttachment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRemakeNotePhotoAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof getRemakeNotePhotoAttachment>>>
export type GetRemakeNotePhotoAttachmentQueryError = ErrorType<void>


/**
 * @summary Serve one private photo attached to an atelier note
 */

export function useGetRemakeNotePhotoAttachment<TData = Awaited<ReturnType<typeof getRemakeNotePhotoAttachment>>, TError = ErrorType<void>>(
 reference: string,
    noteId: number,
    photoId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRemakeNotePhotoAttachment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRemakeNotePhotoAttachmentQueryOptions(reference,noteId,photoId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListRemakeRequestActivityUrl = (reference: string,) => {




  return `/api/owner/remake-requests/${reference}/activity`
}

/**
 * @summary List admin-only activity history for one remake request
 */
export const listRemakeRequestActivity = async (reference: string, options?: Parameters<typeof customFetch>[1]): Promise<RemakeRequestActivity[]> => {

  return customFetch<RemakeRequestActivity[]>(getListRemakeRequestActivityUrl(reference),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRemakeRequestActivityQueryKey = (reference: string,) => {
    return [
    `/api/owner/remake-requests/${reference}/activity`
    ] as const;
    }


export const getListRemakeRequestActivityQueryOptions = <TData = Awaited<ReturnType<typeof listRemakeRequestActivity>>, TError = ErrorType<void>>(reference: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRemakeRequestActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRemakeRequestActivityQueryKey(reference);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRemakeRequestActivity>>> = ({ signal }) => listRemakeRequestActivity(reference, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: reference !== null && reference !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRemakeRequestActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRemakeRequestActivityQueryResult = NonNullable<Awaited<ReturnType<typeof listRemakeRequestActivity>>>
export type ListRemakeRequestActivityQueryError = ErrorType<void>


/**
 * @summary List admin-only activity history for one remake request
 */

export function useListRemakeRequestActivity<TData = Awaited<ReturnType<typeof listRemakeRequestActivity>>, TError = ErrorType<void>>(
 reference: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRemakeRequestActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRemakeRequestActivityQueryOptions(reference,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListRemakeWhatsAppDeliveryStatusesUrl = (reference: string,) => {




  return `/api/owner/remake-requests/${reference}/whatsapp-delivery-statuses`
}

/**
 * @summary Read saved WhatsApp delivery statuses for one remake
 */
export const listRemakeWhatsAppDeliveryStatuses = async (reference: string, options?: Parameters<typeof customFetch>[1]): Promise<RemakeWhatsAppDeliveryStatus[]> => {

  return customFetch<RemakeWhatsAppDeliveryStatus[]>(getListRemakeWhatsAppDeliveryStatusesUrl(reference),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRemakeWhatsAppDeliveryStatusesQueryKey = (reference: string,) => {
    return [
    `/api/owner/remake-requests/${reference}/whatsapp-delivery-statuses`
    ] as const;
    }


export const getListRemakeWhatsAppDeliveryStatusesQueryOptions = <TData = Awaited<ReturnType<typeof listRemakeWhatsAppDeliveryStatuses>>, TError = ErrorType<void>>(reference: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRemakeWhatsAppDeliveryStatuses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRemakeWhatsAppDeliveryStatusesQueryKey(reference);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRemakeWhatsAppDeliveryStatuses>>> = ({ signal }) => listRemakeWhatsAppDeliveryStatuses(reference, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: reference !== null && reference !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRemakeWhatsAppDeliveryStatuses>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRemakeWhatsAppDeliveryStatusesQueryResult = NonNullable<Awaited<ReturnType<typeof listRemakeWhatsAppDeliveryStatuses>>>
export type ListRemakeWhatsAppDeliveryStatusesQueryError = ErrorType<void>


/**
 * @summary Read saved WhatsApp delivery statuses for one remake
 */

export function useListRemakeWhatsAppDeliveryStatuses<TData = Awaited<ReturnType<typeof listRemakeWhatsAppDeliveryStatuses>>, TError = ErrorType<void>>(
 reference: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRemakeWhatsAppDeliveryStatuses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRemakeWhatsAppDeliveryStatusesQueryOptions(reference,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getResendRemakeWhatsAppNotificationUrl = (reference: string,) => {




  return `/api/owner/remake-requests/${reference}/whatsapp-resend`
}

/**
 * @summary Resend a previously sent remake WhatsApp notification
 */
export const resendRemakeWhatsAppNotification = async (reference: string,
    resendRemakeWhatsAppNotificationInput: ResendRemakeWhatsAppNotificationInput, options?: Parameters<typeof customFetch>[1]): Promise<RemakeWhatsAppResendResponse> => {

  return customFetch<RemakeWhatsAppResendResponse>(getResendRemakeWhatsAppNotificationUrl(reference),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resendRemakeWhatsAppNotificationInput)
  }
);}





export const getResendRemakeWhatsAppNotificationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendRemakeWhatsAppNotification>>, TError,{reference: string;data: BodyType<ResendRemakeWhatsAppNotificationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resendRemakeWhatsAppNotification>>, TError,{reference: string;data: BodyType<ResendRemakeWhatsAppNotificationInput>}, TContext> => {

const mutationKey = ['resendRemakeWhatsAppNotification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendRemakeWhatsAppNotification>>, {reference: string;data: BodyType<ResendRemakeWhatsAppNotificationInput>}> = (props) => {
          const {reference,data} = props ?? {};

          return  resendRemakeWhatsAppNotification(reference,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendRemakeWhatsAppNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof resendRemakeWhatsAppNotification>>>
    export type ResendRemakeWhatsAppNotificationMutationBody = BodyType<ResendRemakeWhatsAppNotificationInput>
    export type ResendRemakeWhatsAppNotificationMutationError = ErrorType<void>

    /**
 * @summary Resend a previously sent remake WhatsApp notification
 */
export const useResendRemakeWhatsAppNotification = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendRemakeWhatsAppNotification>>, TError,{reference: string;data: BodyType<ResendRemakeWhatsAppNotificationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resendRemakeWhatsAppNotification>>,
        TError,
        {reference: string;data: BodyType<ResendRemakeWhatsAppNotificationInput>},
        TContext
      > => {
      return useMutation(getResendRemakeWhatsAppNotificationMutationOptions(options));
    }

export const getCreatePriceGateLeadUrl = () => {




  return `/api/price-gate/leads`
}

/**
 * @summary Submit details to reveal a gated product price
 */
export const createPriceGateLead = async (priceGateLeadInput: PriceGateLeadInput, options?: Parameters<typeof customFetch>[1]): Promise<PriceGateLeadResponse> => {

  return customFetch<PriceGateLeadResponse>(getCreatePriceGateLeadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(priceGateLeadInput)
  }
);}





export const getCreatePriceGateLeadMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPriceGateLead>>, TError,{data: BodyType<PriceGateLeadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPriceGateLead>>, TError,{data: BodyType<PriceGateLeadInput>}, TContext> => {

const mutationKey = ['createPriceGateLead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPriceGateLead>>, {data: BodyType<PriceGateLeadInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPriceGateLead(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePriceGateLeadMutationResult = NonNullable<Awaited<ReturnType<typeof createPriceGateLead>>>
    export type CreatePriceGateLeadMutationBody = BodyType<PriceGateLeadInput>
    export type CreatePriceGateLeadMutationError = ErrorType<void>

    /**
 * @summary Submit details to reveal a gated product price
 */
export const useCreatePriceGateLead = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPriceGateLead>>, TError,{data: BodyType<PriceGateLeadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPriceGateLead>>,
        TError,
        {data: BodyType<PriceGateLeadInput>},
        TContext
      > => {
      return useMutation(getCreatePriceGateLeadMutationOptions(options));
    }

export const getGetOwnerRemakeAlertSettingsUrl = () => {




  return `/api/owner/remake-alert-settings`
}

/**
 * @summary Get owner WhatsApp alert recipients
 */
export const getOwnerRemakeAlertSettings = async ( options?: Parameters<typeof customFetch>[1]): Promise<OwnerRemakeAlertSettings> => {

  return customFetch<OwnerRemakeAlertSettings>(getGetOwnerRemakeAlertSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOwnerRemakeAlertSettingsQueryKey = () => {
    return [
    `/api/owner/remake-alert-settings`
    ] as const;
    }


export const getGetOwnerRemakeAlertSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getOwnerRemakeAlertSettings>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOwnerRemakeAlertSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnerRemakeAlertSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwnerRemakeAlertSettings>>> = ({ signal }) => getOwnerRemakeAlertSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOwnerRemakeAlertSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOwnerRemakeAlertSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getOwnerRemakeAlertSettings>>>
export type GetOwnerRemakeAlertSettingsQueryError = ErrorType<void>


/**
 * @summary Get owner WhatsApp alert recipients
 */

export function useGetOwnerRemakeAlertSettings<TData = Awaited<ReturnType<typeof getOwnerRemakeAlertSettings>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOwnerRemakeAlertSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOwnerRemakeAlertSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSaveOwnerRemakeAlertSettingsUrl = () => {




  return `/api/owner/remake-alert-settings`
}

/**
 * @summary Save owner WhatsApp alert recipients
 */
export const saveOwnerRemakeAlertSettings = async (ownerRemakeAlertSettingsInput: OwnerRemakeAlertSettingsInput, options?: Parameters<typeof customFetch>[1]): Promise<OwnerRemakeAlertSettings> => {

  return customFetch<OwnerRemakeAlertSettings>(getSaveOwnerRemakeAlertSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerRemakeAlertSettingsInput)
  }
);}





export const getSaveOwnerRemakeAlertSettingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveOwnerRemakeAlertSettings>>, TError,{data: BodyType<OwnerRemakeAlertSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveOwnerRemakeAlertSettings>>, TError,{data: BodyType<OwnerRemakeAlertSettingsInput>}, TContext> => {

const mutationKey = ['saveOwnerRemakeAlertSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveOwnerRemakeAlertSettings>>, {data: BodyType<OwnerRemakeAlertSettingsInput>}> = (props) => {
          const {data} = props ?? {};

          return  saveOwnerRemakeAlertSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveOwnerRemakeAlertSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof saveOwnerRemakeAlertSettings>>>
    export type SaveOwnerRemakeAlertSettingsMutationBody = BodyType<OwnerRemakeAlertSettingsInput>
    export type SaveOwnerRemakeAlertSettingsMutationError = ErrorType<void>

    /**
 * @summary Save owner WhatsApp alert recipients
 */
export const useSaveOwnerRemakeAlertSettings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveOwnerRemakeAlertSettings>>, TError,{data: BodyType<OwnerRemakeAlertSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveOwnerRemakeAlertSettings>>,
        TError,
        {data: BodyType<OwnerRemakeAlertSettingsInput>},
        TContext
      > => {
      return useMutation(getSaveOwnerRemakeAlertSettingsMutationOptions(options));
    }

export const getListPriceGateLeadsUrl = () => {




  return `/api/owner/price-gate-leads`
}

/**
 * @summary List price reveal leads for the store owner
 */
export const listPriceGateLeads = async ( options?: Parameters<typeof customFetch>[1]): Promise<PriceGateLeadOwner[]> => {

  return customFetch<PriceGateLeadOwner[]>(getListPriceGateLeadsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPriceGateLeadsQueryKey = () => {
    return [
    `/api/owner/price-gate-leads`
    ] as const;
    }


export const getListPriceGateLeadsQueryOptions = <TData = Awaited<ReturnType<typeof listPriceGateLeads>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPriceGateLeads>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPriceGateLeadsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPriceGateLeads>>> = ({ signal }) => listPriceGateLeads({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPriceGateLeads>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPriceGateLeadsQueryResult = NonNullable<Awaited<ReturnType<typeof listPriceGateLeads>>>
export type ListPriceGateLeadsQueryError = ErrorType<void>


/**
 * @summary List price reveal leads for the store owner
 */

export function useListPriceGateLeads<TData = Awaited<ReturnType<typeof listPriceGateLeads>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPriceGateLeads>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPriceGateLeadsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetShopifyProductUrl = (handle: string,) => {




  return `/api/shopify/products/${handle}`
}

/**
 * Send the X-Shopify-Country-Code header (IN, US, AE, or KW) to select market pricing. If omitted, India (IN) is used.
 * @summary Get a storefront product by handle
 */
export const getShopifyProduct = async (handle: string, options?: Parameters<typeof customFetch>[1]): Promise<ShopifyProduct> => {

  return customFetch<ShopifyProduct>(getGetShopifyProductUrl(handle),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShopifyProductQueryKey = (handle: string,) => {
    return [
    `/api/shopify/products/${handle}`
    ] as const;
    }


export const getGetShopifyProductQueryOptions = <TData = Awaited<ReturnType<typeof getShopifyProduct>>, TError = ErrorType<void>>(handle: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyProduct>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShopifyProductQueryKey(handle);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShopifyProduct>>> = ({ signal }) => getShopifyProduct(handle, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: handle !== null && handle !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShopifyProduct>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShopifyProductQueryResult = NonNullable<Awaited<ReturnType<typeof getShopifyProduct>>>
export type GetShopifyProductQueryError = ErrorType<void>


/**
 * @summary Get a storefront product by handle
 */

export function useGetShopifyProduct<TData = Awaited<ReturnType<typeof getShopifyProduct>>, TError = ErrorType<void>>(
 handle: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyProduct>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetShopifyProductQueryOptions(handle,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetShopifyProductInLanguageUrl = (handle: string,
    languageCode: ShopifyLanguageCode,) => {




  return `/api/shopify/products/${handle}/language/${languageCode}`
}

/**
 * @summary Get a storefront product by handle in a language
 */
export const getShopifyProductInLanguage = async (handle: string,
    languageCode: ShopifyLanguageCode, options?: Parameters<typeof customFetch>[1]): Promise<ShopifyProduct> => {

  return customFetch<ShopifyProduct>(getGetShopifyProductInLanguageUrl(handle,languageCode),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShopifyProductInLanguageQueryKey = (handle: string,
    languageCode: ShopifyLanguageCode,) => {
    return [
    `/api/shopify/products/${handle}/language/${languageCode}`
    ] as const;
    }


export const getGetShopifyProductInLanguageQueryOptions = <TData = Awaited<ReturnType<typeof getShopifyProductInLanguage>>, TError = ErrorType<void>>(handle: string,
    languageCode: ShopifyLanguageCode, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyProductInLanguage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShopifyProductInLanguageQueryKey(handle,languageCode);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShopifyProductInLanguage>>> = ({ signal }) => getShopifyProductInLanguage(handle,languageCode, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: handle !== null && handle !== undefined && languageCode !== null && languageCode !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShopifyProductInLanguage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShopifyProductInLanguageQueryResult = NonNullable<Awaited<ReturnType<typeof getShopifyProductInLanguage>>>
export type GetShopifyProductInLanguageQueryError = ErrorType<void>


/**
 * @summary Get a storefront product by handle in a language
 */

export function useGetShopifyProductInLanguage<TData = Awaited<ReturnType<typeof getShopifyProductInLanguage>>, TError = ErrorType<void>>(
 handle: string,
    languageCode: ShopifyLanguageCode, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyProductInLanguage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetShopifyProductInLanguageQueryOptions(handle,languageCode,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getTrackProductViewUrl = () => {




  return `/api/product-engagement/views`
}

/**
 * Counts one visitor per product in the rolling one-hour window.
 * @summary Record an anonymous product view
 */
export const trackProductView = async (productViewInput: ProductViewInput, options?: Parameters<typeof customFetch>[1]): Promise<ProductEngagementResponse> => {

  return customFetch<ProductEngagementResponse>(getTrackProductViewUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(productViewInput)
  }
);}





export const getTrackProductViewMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof trackProductView>>, TError,{data: BodyType<ProductViewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof trackProductView>>, TError,{data: BodyType<ProductViewInput>}, TContext> => {

const mutationKey = ['trackProductView'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof trackProductView>>, {data: BodyType<ProductViewInput>}> = (props) => {
          const {data} = props ?? {};

          return  trackProductView(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TrackProductViewMutationResult = NonNullable<Awaited<ReturnType<typeof trackProductView>>>
    export type TrackProductViewMutationBody = BodyType<ProductViewInput>
    export type TrackProductViewMutationError = ErrorType<void>

    /**
 * @summary Record an anonymous product view
 */
export const useTrackProductView = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof trackProductView>>, TError,{data: BodyType<ProductViewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof trackProductView>>,
        TError,
        {data: BodyType<ProductViewInput>},
        TContext
      > => {
      return useMutation(getTrackProductViewMutationOptions(options));
    }

export const getGetProductEngagementUrl = (handle: string,) => {




  return `/api/product-engagement/${handle}`
}

/**
 * @summary Get recent product engagement counts
 */
export const getProductEngagement = async (handle: string, options?: Parameters<typeof customFetch>[1]): Promise<ProductEngagementResponse> => {

  return customFetch<ProductEngagementResponse>(getGetProductEngagementUrl(handle),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductEngagementQueryKey = (handle: string,) => {
    return [
    `/api/product-engagement/${handle}`
    ] as const;
    }


export const getGetProductEngagementQueryOptions = <TData = Awaited<ReturnType<typeof getProductEngagement>>, TError = ErrorType<void>>(handle: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductEngagement>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductEngagementQueryKey(handle);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductEngagement>>> = ({ signal }) => getProductEngagement(handle, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: handle !== null && handle !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductEngagement>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductEngagementQueryResult = NonNullable<Awaited<ReturnType<typeof getProductEngagement>>>
export type GetProductEngagementQueryError = ErrorType<void>


/**
 * @summary Get recent product engagement counts
 */

export function useGetProductEngagement<TData = Awaited<ReturnType<typeof getProductEngagement>>, TError = ErrorType<void>>(
 handle: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductEngagement>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductEngagementQueryOptions(handle,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateShopifyCartUrl = () => {




  return `/api/shopify/carts`
}

/**
 * @summary Create a cart with its first line
 */
export const createShopifyCart = async (shopifyCartLineInput: ShopifyCartLineInput, options?: Parameters<typeof customFetch>[1]): Promise<ShopifyCart> => {

  return customFetch<ShopifyCart>(getCreateShopifyCartUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shopifyCartLineInput)
  }
);}





export const getCreateShopifyCartMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createShopifyCart>>, TError,{data: BodyType<ShopifyCartLineInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createShopifyCart>>, TError,{data: BodyType<ShopifyCartLineInput>}, TContext> => {

const mutationKey = ['createShopifyCart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createShopifyCart>>, {data: BodyType<ShopifyCartLineInput>}> = (props) => {
          const {data} = props ?? {};

          return  createShopifyCart(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateShopifyCartMutationResult = NonNullable<Awaited<ReturnType<typeof createShopifyCart>>>
    export type CreateShopifyCartMutationBody = BodyType<ShopifyCartLineInput>
    export type CreateShopifyCartMutationError = ErrorType<unknown>

    /**
 * @summary Create a cart with its first line
 */
export const useCreateShopifyCart = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createShopifyCart>>, TError,{data: BodyType<ShopifyCartLineInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createShopifyCart>>,
        TError,
        {data: BodyType<ShopifyCartLineInput>},
        TContext
      > => {
      return useMutation(getCreateShopifyCartMutationOptions(options));
    }

export const getGetShopifyCartUrl = (cartId: string,) => {




  return `/api/shopify/carts/${encodeURIComponent(cartId)}`
}

/**
 * @summary Get a cart
 */
export const getShopifyCart = async (cartId: string, options?: Parameters<typeof customFetch>[1]): Promise<ShopifyCart> => {

  return customFetch<ShopifyCart>(getGetShopifyCartUrl(cartId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShopifyCartQueryKey = (cartId: string,) => {
    return [
    `/api/shopify/carts/${cartId}`
    ] as const;
    }


export const getGetShopifyCartQueryOptions = <TData = Awaited<ReturnType<typeof getShopifyCart>>, TError = ErrorType<void>>(cartId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyCart>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShopifyCartQueryKey(cartId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShopifyCart>>> = ({ signal }) => getShopifyCart(cartId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: cartId !== null && cartId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShopifyCart>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShopifyCartQueryResult = NonNullable<Awaited<ReturnType<typeof getShopifyCart>>>
export type GetShopifyCartQueryError = ErrorType<void>


/**
 * @summary Get a cart
 */

export function useGetShopifyCart<TData = Awaited<ReturnType<typeof getShopifyCart>>, TError = ErrorType<void>>(
 cartId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyCart>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetShopifyCartQueryOptions(cartId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateShopifyCartCheckoutContactUrl = (cartId: string,) => {




  return `/api/shopify/carts/${encodeURIComponent(cartId)}/checkout-contact`
}

/**
 * @summary Save the order phone and transactional WhatsApp consent on a cart
 */
export const updateShopifyCartCheckoutContact = async (cartId: string,
    shopifyCartCheckoutContactInput: ShopifyCartCheckoutContactInput, options?: Parameters<typeof customFetch>[1]): Promise<ShopifyCartCheckoutContactResponse> => {

  return customFetch<ShopifyCartCheckoutContactResponse>(getUpdateShopifyCartCheckoutContactUrl(cartId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shopifyCartCheckoutContactInput)
  }
);}





export const getUpdateShopifyCartCheckoutContactMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateShopifyCartCheckoutContact>>, TError,{cartId: string;data: BodyType<ShopifyCartCheckoutContactInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateShopifyCartCheckoutContact>>, TError,{cartId: string;data: BodyType<ShopifyCartCheckoutContactInput>}, TContext> => {

const mutationKey = ['updateShopifyCartCheckoutContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateShopifyCartCheckoutContact>>, {cartId: string;data: BodyType<ShopifyCartCheckoutContactInput>}> = (props) => {
          const {cartId,data} = props ?? {};

          return  updateShopifyCartCheckoutContact(cartId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateShopifyCartCheckoutContactMutationResult = NonNullable<Awaited<ReturnType<typeof updateShopifyCartCheckoutContact>>>
    export type UpdateShopifyCartCheckoutContactMutationBody = BodyType<ShopifyCartCheckoutContactInput>
    export type UpdateShopifyCartCheckoutContactMutationError = ErrorType<void>

    /**
 * @summary Save the order phone and transactional WhatsApp consent on a cart
 */
export const useUpdateShopifyCartCheckoutContact = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateShopifyCartCheckoutContact>>, TError,{cartId: string;data: BodyType<ShopifyCartCheckoutContactInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateShopifyCartCheckoutContact>>,
        TError,
        {cartId: string;data: BodyType<ShopifyCartCheckoutContactInput>},
        TContext
      > => {
      return useMutation(getUpdateShopifyCartCheckoutContactMutationOptions(options));
    }

export const getGetShopifyCartInLanguageUrl = (cartId: string,
    languageCode: ShopifyLanguageCode,) => {




  return `/api/shopify/carts/${encodeURIComponent(cartId)}/language/${languageCode}`
}

/**
 * @summary Get a cart in a language
 */
export const getShopifyCartInLanguage = async (cartId: string,
    languageCode: ShopifyLanguageCode, options?: Parameters<typeof customFetch>[1]): Promise<ShopifyCart> => {

  return customFetch<ShopifyCart>(getGetShopifyCartInLanguageUrl(cartId,languageCode),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShopifyCartInLanguageQueryKey = (cartId: string,
    languageCode: ShopifyLanguageCode,) => {
    return [
    `/api/shopify/carts/${cartId}/language/${languageCode}`
    ] as const;
    }


export const getGetShopifyCartInLanguageQueryOptions = <TData = Awaited<ReturnType<typeof getShopifyCartInLanguage>>, TError = ErrorType<void>>(cartId: string,
    languageCode: ShopifyLanguageCode, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyCartInLanguage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShopifyCartInLanguageQueryKey(cartId,languageCode);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShopifyCartInLanguage>>> = ({ signal }) => getShopifyCartInLanguage(cartId,languageCode, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: cartId !== null && cartId !== undefined && languageCode !== null && languageCode !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShopifyCartInLanguage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShopifyCartInLanguageQueryResult = NonNullable<Awaited<ReturnType<typeof getShopifyCartInLanguage>>>
export type GetShopifyCartInLanguageQueryError = ErrorType<void>


/**
 * @summary Get a cart in a language
 */

export function useGetShopifyCartInLanguage<TData = Awaited<ReturnType<typeof getShopifyCartInLanguage>>, TError = ErrorType<void>>(
 cartId: string,
    languageCode: ShopifyLanguageCode, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyCartInLanguage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetShopifyCartInLanguageQueryOptions(cartId,languageCode,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddShopifyCartLineUrl = (cartId: string,) => {




  return `/api/shopify/carts/${encodeURIComponent(cartId)}/lines`
}

/**
 * @summary Add a line to a cart
 */
export const addShopifyCartLine = async (cartId: string,
    shopifyCartLineInput: ShopifyCartLineInput, options?: Parameters<typeof customFetch>[1]): Promise<ShopifyCart> => {

  return customFetch<ShopifyCart>(getAddShopifyCartLineUrl(cartId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shopifyCartLineInput)
  }
);}





export const getAddShopifyCartLineMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addShopifyCartLine>>, TError,{cartId: string;data: BodyType<ShopifyCartLineInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addShopifyCartLine>>, TError,{cartId: string;data: BodyType<ShopifyCartLineInput>}, TContext> => {

const mutationKey = ['addShopifyCartLine'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addShopifyCartLine>>, {cartId: string;data: BodyType<ShopifyCartLineInput>}> = (props) => {
          const {cartId,data} = props ?? {};

          return  addShopifyCartLine(cartId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddShopifyCartLineMutationResult = NonNullable<Awaited<ReturnType<typeof addShopifyCartLine>>>
    export type AddShopifyCartLineMutationBody = BodyType<ShopifyCartLineInput>
    export type AddShopifyCartLineMutationError = ErrorType<unknown>

    /**
 * @summary Add a line to a cart
 */
export const useAddShopifyCartLine = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addShopifyCartLine>>, TError,{cartId: string;data: BodyType<ShopifyCartLineInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addShopifyCartLine>>,
        TError,
        {cartId: string;data: BodyType<ShopifyCartLineInput>},
        TContext
      > => {
      return useMutation(getAddShopifyCartLineMutationOptions(options));
    }

export const getUpdateShopifyCartLineUrl = (cartId: string,
    lineId: string,) => {




  return `/api/shopify/carts/${encodeURIComponent(cartId)}/lines/${encodeURIComponent(lineId)}`
}

/**
 * @summary Change a cart line quantity
 */
export const updateShopifyCartLine = async (cartId: string,
    lineId: string,
    shopifyCartLineUpdate: ShopifyCartLineUpdate, options?: Parameters<typeof customFetch>[1]): Promise<ShopifyCart> => {

  return customFetch<ShopifyCart>(getUpdateShopifyCartLineUrl(cartId,lineId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shopifyCartLineUpdate)
  }
);}





export const getUpdateShopifyCartLineMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateShopifyCartLine>>, TError,{cartId: string;lineId: string;data: BodyType<ShopifyCartLineUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateShopifyCartLine>>, TError,{cartId: string;lineId: string;data: BodyType<ShopifyCartLineUpdate>}, TContext> => {

const mutationKey = ['updateShopifyCartLine'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateShopifyCartLine>>, {cartId: string;lineId: string;data: BodyType<ShopifyCartLineUpdate>}> = (props) => {
          const {cartId,lineId,data} = props ?? {};

          return  updateShopifyCartLine(cartId,lineId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateShopifyCartLineMutationResult = NonNullable<Awaited<ReturnType<typeof updateShopifyCartLine>>>
    export type UpdateShopifyCartLineMutationBody = BodyType<ShopifyCartLineUpdate>
    export type UpdateShopifyCartLineMutationError = ErrorType<unknown>

    /**
 * @summary Change a cart line quantity
 */
export const useUpdateShopifyCartLine = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateShopifyCartLine>>, TError,{cartId: string;lineId: string;data: BodyType<ShopifyCartLineUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateShopifyCartLine>>,
        TError,
        {cartId: string;lineId: string;data: BodyType<ShopifyCartLineUpdate>},
        TContext
      > => {
      return useMutation(getUpdateShopifyCartLineMutationOptions(options));
    }

export const getRemoveShopifyCartLineUrl = (cartId: string,
    lineId: string,) => {




  return `/api/shopify/carts/${encodeURIComponent(cartId)}/lines/${encodeURIComponent(lineId)}`
}

/**
 * @summary Remove a cart line
 */
export const removeShopifyCartLine = async (cartId: string,
    lineId: string, options?: Parameters<typeof customFetch>[1]): Promise<ShopifyCart> => {

  return customFetch<ShopifyCart>(getRemoveShopifyCartLineUrl(cartId,lineId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveShopifyCartLineMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeShopifyCartLine>>, TError,{cartId: string;lineId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeShopifyCartLine>>, TError,{cartId: string;lineId: string}, TContext> => {

const mutationKey = ['removeShopifyCartLine'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeShopifyCartLine>>, {cartId: string;lineId: string}> = (props) => {
          const {cartId,lineId} = props ?? {};

          return  removeShopifyCartLine(cartId,lineId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveShopifyCartLineMutationResult = NonNullable<Awaited<ReturnType<typeof removeShopifyCartLine>>>

    export type RemoveShopifyCartLineMutationError = ErrorType<unknown>

    /**
 * @summary Remove a cart line
 */
export const useRemoveShopifyCartLine = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeShopifyCartLine>>, TError,{cartId: string;lineId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeShopifyCartLine>>,
        TError,
        {cartId: string;lineId: string},
        TContext
      > => {
      return useMutation(getRemoveShopifyCartLineMutationOptions(options));
    }

export const getRemoveShopifyCartLineInLanguageUrl = (cartId: string,
    lineId: string,
    languageCode: ShopifyLanguageCode,) => {




  return `/api/shopify/carts/${encodeURIComponent(cartId)}/lines/${encodeURIComponent(lineId)}/language/${languageCode}`
}

/**
 * @summary Remove a cart line in a language
 */
export const removeShopifyCartLineInLanguage = async (cartId: string,
    lineId: string,
    languageCode: ShopifyLanguageCode, options?: Parameters<typeof customFetch>[1]): Promise<ShopifyCart> => {

  return customFetch<ShopifyCart>(getRemoveShopifyCartLineInLanguageUrl(cartId,lineId,languageCode),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveShopifyCartLineInLanguageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeShopifyCartLineInLanguage>>, TError,{cartId: string;lineId: string;languageCode: ShopifyLanguageCode}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeShopifyCartLineInLanguage>>, TError,{cartId: string;lineId: string;languageCode: ShopifyLanguageCode}, TContext> => {

const mutationKey = ['removeShopifyCartLineInLanguage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeShopifyCartLineInLanguage>>, {cartId: string;lineId: string;languageCode: ShopifyLanguageCode}> = (props) => {
          const {cartId,lineId,languageCode} = props ?? {};

          return  removeShopifyCartLineInLanguage(cartId,lineId,languageCode,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveShopifyCartLineInLanguageMutationResult = NonNullable<Awaited<ReturnType<typeof removeShopifyCartLineInLanguage>>>

    export type RemoveShopifyCartLineInLanguageMutationError = ErrorType<unknown>

    /**
 * @summary Remove a cart line in a language
 */
export const useRemoveShopifyCartLineInLanguage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeShopifyCartLineInLanguage>>, TError,{cartId: string;lineId: string;languageCode: ShopifyLanguageCode}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeShopifyCartLineInLanguage>>,
        TError,
        {cartId: string;lineId: string;languageCode: ShopifyLanguageCode},
        TContext
      > => {
      return useMutation(getRemoveShopifyCartLineInLanguageMutationOptions(options));
    }

export const getListProductReviewsUrl = (handle: string,) => {




  return `/api/reviews/products/${handle}`
}

/**
 * @summary List approved reviews for a product
 */
export const listProductReviews = async (handle: string, options?: Parameters<typeof customFetch>[1]): Promise<ProductReviewsResponse> => {

  return customFetch<ProductReviewsResponse>(getListProductReviewsUrl(handle),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProductReviewsQueryKey = (handle: string,) => {
    return [
    `/api/reviews/products/${handle}`
    ] as const;
    }


export const getListProductReviewsQueryOptions = <TData = Awaited<ReturnType<typeof listProductReviews>>, TError = ErrorType<unknown>>(handle: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProductReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductReviewsQueryKey(handle);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProductReviews>>> = ({ signal }) => listProductReviews(handle, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: handle !== null && handle !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProductReviews>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProductReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof listProductReviews>>>
export type ListProductReviewsQueryError = ErrorType<unknown>


/**
 * @summary List approved reviews for a product
 */

export function useListProductReviews<TData = Awaited<ReturnType<typeof listProductReviews>>, TError = ErrorType<unknown>>(
 handle: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProductReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProductReviewsQueryOptions(handle,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetGoogleReviewsUrl = () => {




  return `/api/google-reviews`
}

/**
 * @summary List the latest four-star-and-above Google reviews
 */
export const getGoogleReviews = async ( options?: Parameters<typeof customFetch>[1]): Promise<GoogleReviewsResponse> => {

  return customFetch<GoogleReviewsResponse>(getGetGoogleReviewsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGoogleReviewsQueryKey = () => {
    return [
    `/api/google-reviews`
    ] as const;
    }


export const getGetGoogleReviewsQueryOptions = <TData = Awaited<ReturnType<typeof getGoogleReviews>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGoogleReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGoogleReviewsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGoogleReviews>>> = ({ signal }) => getGoogleReviews({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGoogleReviews>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGoogleReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof getGoogleReviews>>>
export type GetGoogleReviewsQueryError = ErrorType<void>


/**
 * @summary List the latest four-star-and-above Google reviews
 */

export function useGetGoogleReviews<TData = Awaited<ReturnType<typeof getGoogleReviews>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGoogleReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGoogleReviewsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetApprovedReviewMediaUrl = (id: string,) => {




  return `/api/reviews/media/${id}`
}

/**
 * @summary Stream media from an approved review
 */
export const getApprovedReviewMedia = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<Blob> => {

  return customFetch<Blob>(getGetApprovedReviewMediaUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApprovedReviewMediaQueryKey = (id: string,) => {
    return [
    `/api/reviews/media/${id}`
    ] as const;
    }


export const getGetApprovedReviewMediaQueryOptions = <TData = Awaited<ReturnType<typeof getApprovedReviewMedia>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApprovedReviewMedia>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApprovedReviewMediaQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovedReviewMedia>>> = ({ signal }) => getApprovedReviewMedia(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApprovedReviewMedia>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApprovedReviewMediaQueryResult = NonNullable<Awaited<ReturnType<typeof getApprovedReviewMedia>>>
export type GetApprovedReviewMediaQueryError = ErrorType<void>


/**
 * @summary Stream media from an approved review
 */

export function useGetApprovedReviewMedia<TData = Awaited<ReturnType<typeof getApprovedReviewMedia>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApprovedReviewMedia>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApprovedReviewMediaQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetReviewInvitationUrl = (id: string,) => {




  return `/api/reviews/invitations/${id}`
}

/**
 * @summary Get a purchase-linked review invitation
 */
export const getReviewInvitation = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ReviewInvitation> => {

  return customFetch<ReviewInvitation>(getGetReviewInvitationUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReviewInvitationQueryKey = (id: string,) => {
    return [
    `/api/reviews/invitations/${id}`
    ] as const;
    }


export const getGetReviewInvitationQueryOptions = <TData = Awaited<ReturnType<typeof getReviewInvitation>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReviewInvitation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReviewInvitationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReviewInvitation>>> = ({ signal }) => getReviewInvitation(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReviewInvitation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReviewInvitationQueryResult = NonNullable<Awaited<ReturnType<typeof getReviewInvitation>>>
export type GetReviewInvitationQueryError = ErrorType<void>


/**
 * @summary Get a purchase-linked review invitation
 */

export function useGetReviewInvitation<TData = Awaited<ReturnType<typeof getReviewInvitation>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReviewInvitation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReviewInvitationQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubmitReviewUrl = (id: string,) => {




  return `/api/reviews/invitations/${id}`
}

/**
 * @summary Submit a review from a purchase-linked invitation
 */
export const submitReview = async (id: string,
    reviewSubmissionInput: ReviewSubmissionInput, options?: Parameters<typeof customFetch>[1]): Promise<ReviewSubmissionResponse> => {

  return customFetch<ReviewSubmissionResponse>(getSubmitReviewUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reviewSubmissionInput)
  }
);}





export const getSubmitReviewMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitReview>>, TError,{id: string;data: BodyType<ReviewSubmissionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitReview>>, TError,{id: string;data: BodyType<ReviewSubmissionInput>}, TContext> => {

const mutationKey = ['submitReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitReview>>, {id: string;data: BodyType<ReviewSubmissionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  submitReview(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitReviewMutationResult = NonNullable<Awaited<ReturnType<typeof submitReview>>>
    export type SubmitReviewMutationBody = BodyType<ReviewSubmissionInput>
    export type SubmitReviewMutationError = ErrorType<void>

    /**
 * @summary Submit a review from a purchase-linked invitation
 */
export const useSubmitReview = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitReview>>, TError,{id: string;data: BodyType<ReviewSubmissionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitReview>>,
        TError,
        {id: string;data: BodyType<ReviewSubmissionInput>},
        TContext
      > => {
      return useMutation(getSubmitReviewMutationOptions(options));
    }

export const getRequestReviewUploadUrl = (id: string,) => {




  return `/api/reviews/invitations/${id}/uploads`
}

/**
 * @summary Request a presigned upload URL for review media
 */
export const requestReviewUpload = async (id: string,
    reviewUploadRequest: ReviewUploadRequest, options?: Parameters<typeof customFetch>[1]): Promise<ReviewUploadResponse> => {

  return customFetch<ReviewUploadResponse>(getRequestReviewUploadUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reviewUploadRequest)
  }
);}





export const getRequestReviewUploadMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestReviewUpload>>, TError,{id: string;data: BodyType<ReviewUploadRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestReviewUpload>>, TError,{id: string;data: BodyType<ReviewUploadRequest>}, TContext> => {

const mutationKey = ['requestReviewUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestReviewUpload>>, {id: string;data: BodyType<ReviewUploadRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  requestReviewUpload(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestReviewUploadMutationResult = NonNullable<Awaited<ReturnType<typeof requestReviewUpload>>>
    export type RequestReviewUploadMutationBody = BodyType<ReviewUploadRequest>
    export type RequestReviewUploadMutationError = ErrorType<void>

    /**
 * @summary Request a presigned upload URL for review media
 */
export const useRequestReviewUpload = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestReviewUpload>>, TError,{id: string;data: BodyType<ReviewUploadRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestReviewUpload>>,
        TError,
        {id: string;data: BodyType<ReviewUploadRequest>},
        TContext
      > => {
      return useMutation(getRequestReviewUploadMutationOptions(options));
    }

export const getListOwnerReviewsUrl = () => {




  return `/api/owner/reviews`
}

/**
 * @summary List customer reviews for moderation
 */
export const listOwnerReviews = async ( options?: Parameters<typeof customFetch>[1]): Promise<OwnerReviewsResponse> => {

  return customFetch<OwnerReviewsResponse>(getListOwnerReviewsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOwnerReviewsQueryKey = () => {
    return [
    `/api/owner/reviews`
    ] as const;
    }


export const getListOwnerReviewsQueryOptions = <TData = Awaited<ReturnType<typeof listOwnerReviews>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOwnerReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOwnerReviewsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOwnerReviews>>> = ({ signal }) => listOwnerReviews({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOwnerReviews>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOwnerReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof listOwnerReviews>>>
export type ListOwnerReviewsQueryError = ErrorType<void>


/**
 * @summary List customer reviews for moderation
 */

export function useListOwnerReviews<TData = Awaited<ReturnType<typeof listOwnerReviews>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOwnerReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOwnerReviewsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getModerateReviewUrl = (id: string,) => {




  return `/api/owner/reviews/${id}`
}

/**
 * @summary Approve or reject a customer review
 */
export const moderateReview = async (id: string,
    moderateReviewInput: ModerateReviewInput, options?: Parameters<typeof customFetch>[1]): Promise<OwnerReview> => {

  return customFetch<OwnerReview>(getModerateReviewUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(moderateReviewInput)
  }
);}





export const getModerateReviewMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderateReview>>, TError,{id: string;data: BodyType<ModerateReviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof moderateReview>>, TError,{id: string;data: BodyType<ModerateReviewInput>}, TContext> => {

const mutationKey = ['moderateReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderateReview>>, {id: string;data: BodyType<ModerateReviewInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  moderateReview(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ModerateReviewMutationResult = NonNullable<Awaited<ReturnType<typeof moderateReview>>>
    export type ModerateReviewMutationBody = BodyType<ModerateReviewInput>
    export type ModerateReviewMutationError = ErrorType<void>

    /**
 * @summary Approve or reject a customer review
 */
export const useModerateReview = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderateReview>>, TError,{id: string;data: BodyType<ModerateReviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof moderateReview>>,
        TError,
        {id: string;data: BodyType<ModerateReviewInput>},
        TContext
      > => {
      return useMutation(getModerateReviewMutationOptions(options));
    }

export const getGetOwnerReviewMediaUrl = (id: string,) => {




  return `/api/owner/reviews/media/${id}`
}

/**
 * @summary Stream review media for the owner
 */
export const getOwnerReviewMedia = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<Blob> => {

  return customFetch<Blob>(getGetOwnerReviewMediaUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOwnerReviewMediaQueryKey = (id: string,) => {
    return [
    `/api/owner/reviews/media/${id}`
    ] as const;
    }


export const getGetOwnerReviewMediaQueryOptions = <TData = Awaited<ReturnType<typeof getOwnerReviewMedia>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOwnerReviewMedia>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnerReviewMediaQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwnerReviewMedia>>> = ({ signal }) => getOwnerReviewMedia(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOwnerReviewMedia>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOwnerReviewMediaQueryResult = NonNullable<Awaited<ReturnType<typeof getOwnerReviewMedia>>>
export type GetOwnerReviewMediaQueryError = ErrorType<void>


/**
 * @summary Stream review media for the owner
 */

export function useGetOwnerReviewMedia<TData = Awaited<ReturnType<typeof getOwnerReviewMedia>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOwnerReviewMedia>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOwnerReviewMediaQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetReviewSettingsUrl = () => {




  return `/api/owner/reviews/settings`
}

/**
 * @summary Get review reward settings
 */
export const getReviewSettings = async ( options?: Parameters<typeof customFetch>[1]): Promise<ReviewSettings> => {

  return customFetch<ReviewSettings>(getGetReviewSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReviewSettingsQueryKey = () => {
    return [
    `/api/owner/reviews/settings`
    ] as const;
    }


export const getGetReviewSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getReviewSettings>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReviewSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReviewSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReviewSettings>>> = ({ signal }) => getReviewSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReviewSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReviewSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getReviewSettings>>>
export type GetReviewSettingsQueryError = ErrorType<void>


/**
 * @summary Get review reward settings
 */

export function useGetReviewSettings<TData = Awaited<ReturnType<typeof getReviewSettings>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReviewSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReviewSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateReviewSettingsUrl = () => {




  return `/api/owner/reviews/settings`
}

/**
 * @summary Update review reward settings
 */
export const updateReviewSettings = async (reviewSettingsUpdate: ReviewSettingsUpdate, options?: Parameters<typeof customFetch>[1]): Promise<ReviewSettings> => {

  return customFetch<ReviewSettings>(getUpdateReviewSettingsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reviewSettingsUpdate)
  }
);}





export const getUpdateReviewSettingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReviewSettings>>, TError,{data: BodyType<ReviewSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateReviewSettings>>, TError,{data: BodyType<ReviewSettingsUpdate>}, TContext> => {

const mutationKey = ['updateReviewSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateReviewSettings>>, {data: BodyType<ReviewSettingsUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateReviewSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateReviewSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateReviewSettings>>>
    export type UpdateReviewSettingsMutationBody = BodyType<ReviewSettingsUpdate>
    export type UpdateReviewSettingsMutationError = ErrorType<void>

    /**
 * @summary Update review reward settings
 */
export const useUpdateReviewSettings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReviewSettings>>, TError,{data: BodyType<ReviewSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateReviewSettings>>,
        TError,
        {data: BodyType<ReviewSettingsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateReviewSettingsMutationOptions(options));
    }

export const getGetGoogleReviewSettingsUrl = () => {




  return `/api/owner/google-reviews/settings`
}

/**
 * @summary Get homepage Google review settings
 */
export const getGoogleReviewSettings = async ( options?: Parameters<typeof customFetch>[1]): Promise<GoogleReviewSettings> => {

  return customFetch<GoogleReviewSettings>(getGetGoogleReviewSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGoogleReviewSettingsQueryKey = () => {
    return [
    `/api/owner/google-reviews/settings`
    ] as const;
    }


export const getGetGoogleReviewSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getGoogleReviewSettings>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGoogleReviewSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGoogleReviewSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGoogleReviewSettings>>> = ({ signal }) => getGoogleReviewSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGoogleReviewSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGoogleReviewSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getGoogleReviewSettings>>>
export type GetGoogleReviewSettingsQueryError = ErrorType<void>


/**
 * @summary Get homepage Google review settings
 */

export function useGetGoogleReviewSettings<TData = Awaited<ReturnType<typeof getGoogleReviewSettings>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGoogleReviewSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGoogleReviewSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateGoogleReviewSettingsUrl = () => {




  return `/api/owner/google-reviews/settings`
}

/**
 * @summary Update homepage Google review settings
 */
export const updateGoogleReviewSettings = async (googleReviewSettingsUpdate: GoogleReviewSettingsUpdate, options?: Parameters<typeof customFetch>[1]): Promise<GoogleReviewSettings> => {

  return customFetch<GoogleReviewSettings>(getUpdateGoogleReviewSettingsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(googleReviewSettingsUpdate)
  }
);}





export const getUpdateGoogleReviewSettingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGoogleReviewSettings>>, TError,{data: BodyType<GoogleReviewSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateGoogleReviewSettings>>, TError,{data: BodyType<GoogleReviewSettingsUpdate>}, TContext> => {

const mutationKey = ['updateGoogleReviewSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGoogleReviewSettings>>, {data: BodyType<GoogleReviewSettingsUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateGoogleReviewSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateGoogleReviewSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateGoogleReviewSettings>>>
    export type UpdateGoogleReviewSettingsMutationBody = BodyType<GoogleReviewSettingsUpdate>
    export type UpdateGoogleReviewSettingsMutationError = ErrorType<void>

    /**
 * @summary Update homepage Google review settings
 */
export const useUpdateGoogleReviewSettings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGoogleReviewSettings>>, TError,{data: BodyType<GoogleReviewSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateGoogleReviewSettings>>,
        TError,
        {data: BodyType<GoogleReviewSettingsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateGoogleReviewSettingsMutationOptions(options));
    }

export const getConnectGoogleBusinessProfileUrl = () => {




  return `/api/owner/google-business-profile/connect`
}

/**
 * @summary Start Google Business Profile OAuth
 */
export const connectGoogleBusinessProfile = async ( options?: Parameters<typeof customFetch>[1]): Promise<GoogleBusinessProfileConnectResponse> => {

  return customFetch<GoogleBusinessProfileConnectResponse>(getConnectGoogleBusinessProfileUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getConnectGoogleBusinessProfileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectGoogleBusinessProfile>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof connectGoogleBusinessProfile>>, TError,void, TContext> => {

const mutationKey = ['connectGoogleBusinessProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectGoogleBusinessProfile>>, void> = () => {


          return  connectGoogleBusinessProfile(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectGoogleBusinessProfileMutationResult = NonNullable<Awaited<ReturnType<typeof connectGoogleBusinessProfile>>>

    export type ConnectGoogleBusinessProfileMutationError = ErrorType<void>

    /**
 * @summary Start Google Business Profile OAuth
 */
export const useConnectGoogleBusinessProfile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectGoogleBusinessProfile>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof connectGoogleBusinessProfile>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getConnectGoogleBusinessProfileMutationOptions(options));
    }

export const getGetGoogleBusinessProfileStatusUrl = () => {




  return `/api/owner/google-business-profile/status`
}

/**
 * @summary Get Google Business Profile connection status
 */
export const getGoogleBusinessProfileStatus = async ( options?: Parameters<typeof customFetch>[1]): Promise<GoogleBusinessProfileStatus> => {

  return customFetch<GoogleBusinessProfileStatus>(getGetGoogleBusinessProfileStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGoogleBusinessProfileStatusQueryKey = () => {
    return [
    `/api/owner/google-business-profile/status`
    ] as const;
    }


export const getGetGoogleBusinessProfileStatusQueryOptions = <TData = Awaited<ReturnType<typeof getGoogleBusinessProfileStatus>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGoogleBusinessProfileStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGoogleBusinessProfileStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGoogleBusinessProfileStatus>>> = ({ signal }) => getGoogleBusinessProfileStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGoogleBusinessProfileStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGoogleBusinessProfileStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getGoogleBusinessProfileStatus>>>
export type GetGoogleBusinessProfileStatusQueryError = ErrorType<void>


/**
 * @summary Get Google Business Profile connection status
 */

export function useGetGoogleBusinessProfileStatus<TData = Awaited<ReturnType<typeof getGoogleBusinessProfileStatus>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGoogleBusinessProfileStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGoogleBusinessProfileStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSelectGoogleBusinessProfileLocationUrl = () => {




  return `/api/owner/google-business-profile/location`
}

/**
 * @summary Select the Google Business Profile location to sync
 */
export const selectGoogleBusinessProfileLocation = async (googleBusinessProfileLocationUpdate: GoogleBusinessProfileLocationUpdate, options?: Parameters<typeof customFetch>[1]): Promise<GoogleBusinessProfileLocationSelection> => {

  return customFetch<GoogleBusinessProfileLocationSelection>(getSelectGoogleBusinessProfileLocationUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(googleBusinessProfileLocationUpdate)
  }
);}





export const getSelectGoogleBusinessProfileLocationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof selectGoogleBusinessProfileLocation>>, TError,{data: BodyType<GoogleBusinessProfileLocationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof selectGoogleBusinessProfileLocation>>, TError,{data: BodyType<GoogleBusinessProfileLocationUpdate>}, TContext> => {

const mutationKey = ['selectGoogleBusinessProfileLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof selectGoogleBusinessProfileLocation>>, {data: BodyType<GoogleBusinessProfileLocationUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  selectGoogleBusinessProfileLocation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SelectGoogleBusinessProfileLocationMutationResult = NonNullable<Awaited<ReturnType<typeof selectGoogleBusinessProfileLocation>>>
    export type SelectGoogleBusinessProfileLocationMutationBody = BodyType<GoogleBusinessProfileLocationUpdate>
    export type SelectGoogleBusinessProfileLocationMutationError = ErrorType<void>

    /**
 * @summary Select the Google Business Profile location to sync
 */
export const useSelectGoogleBusinessProfileLocation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof selectGoogleBusinessProfileLocation>>, TError,{data: BodyType<GoogleBusinessProfileLocationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof selectGoogleBusinessProfileLocation>>,
        TError,
        {data: BodyType<GoogleBusinessProfileLocationUpdate>},
        TContext
      > => {
      return useMutation(getSelectGoogleBusinessProfileLocationMutationOptions(options));
    }

export const getSyncGoogleBusinessProfileReviewsUrl = () => {




  return `/api/owner/google-business-profile/sync`
}

/**
 * @summary Sync all Google Business Profile reviews
 */
export const syncGoogleBusinessProfileReviews = async ( options?: Parameters<typeof customFetch>[1]): Promise<GoogleBusinessProfileSyncResponse> => {

  return customFetch<GoogleBusinessProfileSyncResponse>(getSyncGoogleBusinessProfileReviewsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSyncGoogleBusinessProfileReviewsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncGoogleBusinessProfileReviews>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncGoogleBusinessProfileReviews>>, TError,void, TContext> => {

const mutationKey = ['syncGoogleBusinessProfileReviews'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncGoogleBusinessProfileReviews>>, void> = () => {


          return  syncGoogleBusinessProfileReviews(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncGoogleBusinessProfileReviewsMutationResult = NonNullable<Awaited<ReturnType<typeof syncGoogleBusinessProfileReviews>>>

    export type SyncGoogleBusinessProfileReviewsMutationError = ErrorType<void>

    /**
 * @summary Sync all Google Business Profile reviews
 */
export const useSyncGoogleBusinessProfileReviews = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncGoogleBusinessProfileReviews>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncGoogleBusinessProfileReviews>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSyncGoogleBusinessProfileReviewsMutationOptions(options));
    }

export const getDisconnectGoogleBusinessProfileUrl = () => {




  return `/api/owner/google-business-profile/disconnect`
}

/**
 * @summary Disconnect Google Business Profile
 */
export const disconnectGoogleBusinessProfile = async ( options?: Parameters<typeof customFetch>[1]): Promise<DisconnectGoogleBusinessProfile200> => {

  return customFetch<DisconnectGoogleBusinessProfile200>(getDisconnectGoogleBusinessProfileUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDisconnectGoogleBusinessProfileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectGoogleBusinessProfile>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectGoogleBusinessProfile>>, TError,void, TContext> => {

const mutationKey = ['disconnectGoogleBusinessProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectGoogleBusinessProfile>>, void> = () => {


          return  disconnectGoogleBusinessProfile(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectGoogleBusinessProfileMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectGoogleBusinessProfile>>>

    export type DisconnectGoogleBusinessProfileMutationError = ErrorType<void>

    /**
 * @summary Disconnect Google Business Profile
 */
export const useDisconnectGoogleBusinessProfile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectGoogleBusinessProfile>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof disconnectGoogleBusinessProfile>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDisconnectGoogleBusinessProfileMutationOptions(options));
    }

export const getConnectGoogleAnalyticsUrl = () => {




  return `/api/owner/google-analytics/connect`
}

/**
 * @summary Start the read-only Google Analytics and Search Console connection
 */
export const connectGoogleAnalytics = async ( options?: Parameters<typeof customFetch>[1]): Promise<GoogleAnalyticsConnectResponse> => {

  return customFetch<GoogleAnalyticsConnectResponse>(getConnectGoogleAnalyticsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getConnectGoogleAnalyticsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectGoogleAnalytics>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof connectGoogleAnalytics>>, TError,void, TContext> => {

const mutationKey = ['connectGoogleAnalytics'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectGoogleAnalytics>>, void> = () => {


          return  connectGoogleAnalytics(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectGoogleAnalyticsMutationResult = NonNullable<Awaited<ReturnType<typeof connectGoogleAnalytics>>>

    export type ConnectGoogleAnalyticsMutationError = ErrorType<void>

    /**
 * @summary Start the read-only Google Analytics and Search Console connection
 */
export const useConnectGoogleAnalytics = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectGoogleAnalytics>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof connectGoogleAnalytics>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getConnectGoogleAnalyticsMutationOptions(options));
    }

export const getGetGoogleAnalyticsStatusUrl = () => {




  return `/api/owner/google-analytics/status`
}

/**
 * @summary Get Google reporting connection and selected report targets
 */
export const getGoogleAnalyticsStatus = async ( options?: Parameters<typeof customFetch>[1]): Promise<GoogleAnalyticsStatus> => {

  return customFetch<GoogleAnalyticsStatus>(getGetGoogleAnalyticsStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGoogleAnalyticsStatusQueryKey = () => {
    return [
    `/api/owner/google-analytics/status`
    ] as const;
    }


export const getGetGoogleAnalyticsStatusQueryOptions = <TData = Awaited<ReturnType<typeof getGoogleAnalyticsStatus>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGoogleAnalyticsStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGoogleAnalyticsStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGoogleAnalyticsStatus>>> = ({ signal }) => getGoogleAnalyticsStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGoogleAnalyticsStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGoogleAnalyticsStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getGoogleAnalyticsStatus>>>
export type GetGoogleAnalyticsStatusQueryError = ErrorType<void>


/**
 * @summary Get Google reporting connection and selected report targets
 */

export function useGetGoogleAnalyticsStatus<TData = Awaited<ReturnType<typeof getGoogleAnalyticsStatus>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGoogleAnalyticsStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGoogleAnalyticsStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListGoogleAnalyticsPropertiesUrl = () => {




  return `/api/owner/google-analytics/properties`
}

/**
 * @summary List accessible GA4 properties
 */
export const listGoogleAnalyticsProperties = async ( options?: Parameters<typeof customFetch>[1]): Promise<GoogleAnalyticsProperty[]> => {

  return customFetch<GoogleAnalyticsProperty[]>(getListGoogleAnalyticsPropertiesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGoogleAnalyticsPropertiesQueryKey = () => {
    return [
    `/api/owner/google-analytics/properties`
    ] as const;
    }


export const getListGoogleAnalyticsPropertiesQueryOptions = <TData = Awaited<ReturnType<typeof listGoogleAnalyticsProperties>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGoogleAnalyticsProperties>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGoogleAnalyticsPropertiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGoogleAnalyticsProperties>>> = ({ signal }) => listGoogleAnalyticsProperties({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGoogleAnalyticsProperties>>, TError, TData> & { queryKey: QueryKey }
}

export type ListGoogleAnalyticsPropertiesQueryResult = NonNullable<Awaited<ReturnType<typeof listGoogleAnalyticsProperties>>>
export type ListGoogleAnalyticsPropertiesQueryError = ErrorType<void>


/**
 * @summary List accessible GA4 properties
 */

export function useListGoogleAnalyticsProperties<TData = Awaited<ReturnType<typeof listGoogleAnalyticsProperties>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGoogleAnalyticsProperties>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListGoogleAnalyticsPropertiesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListGoogleSearchConsoleSitesUrl = () => {




  return `/api/owner/google-analytics/sites`
}

/**
 * @summary List accessible Search Console sites
 */
export const listGoogleSearchConsoleSites = async ( options?: Parameters<typeof customFetch>[1]): Promise<GoogleSearchConsoleSite[]> => {

  return customFetch<GoogleSearchConsoleSite[]>(getListGoogleSearchConsoleSitesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGoogleSearchConsoleSitesQueryKey = () => {
    return [
    `/api/owner/google-analytics/sites`
    ] as const;
    }


export const getListGoogleSearchConsoleSitesQueryOptions = <TData = Awaited<ReturnType<typeof listGoogleSearchConsoleSites>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGoogleSearchConsoleSites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGoogleSearchConsoleSitesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGoogleSearchConsoleSites>>> = ({ signal }) => listGoogleSearchConsoleSites({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGoogleSearchConsoleSites>>, TError, TData> & { queryKey: QueryKey }
}

export type ListGoogleSearchConsoleSitesQueryResult = NonNullable<Awaited<ReturnType<typeof listGoogleSearchConsoleSites>>>
export type ListGoogleSearchConsoleSitesQueryError = ErrorType<void>


/**
 * @summary List accessible Search Console sites
 */

export function useListGoogleSearchConsoleSites<TData = Awaited<ReturnType<typeof listGoogleSearchConsoleSites>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGoogleSearchConsoleSites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListGoogleSearchConsoleSitesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSelectGoogleAnalyticsPropertyUrl = () => {




  return `/api/owner/google-analytics/property`
}

/**
 * @summary Select the GA4 property to report on
 */
export const selectGoogleAnalyticsProperty = async (googleAnalyticsPropertySelectionInput: GoogleAnalyticsPropertySelectionInput, options?: Parameters<typeof customFetch>[1]): Promise<GoogleAnalyticsStatus> => {

  return customFetch<GoogleAnalyticsStatus>(getSelectGoogleAnalyticsPropertyUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(googleAnalyticsPropertySelectionInput)
  }
);}





export const getSelectGoogleAnalyticsPropertyMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof selectGoogleAnalyticsProperty>>, TError,{data: BodyType<GoogleAnalyticsPropertySelectionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof selectGoogleAnalyticsProperty>>, TError,{data: BodyType<GoogleAnalyticsPropertySelectionInput>}, TContext> => {

const mutationKey = ['selectGoogleAnalyticsProperty'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof selectGoogleAnalyticsProperty>>, {data: BodyType<GoogleAnalyticsPropertySelectionInput>}> = (props) => {
          const {data} = props ?? {};

          return  selectGoogleAnalyticsProperty(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SelectGoogleAnalyticsPropertyMutationResult = NonNullable<Awaited<ReturnType<typeof selectGoogleAnalyticsProperty>>>
    export type SelectGoogleAnalyticsPropertyMutationBody = BodyType<GoogleAnalyticsPropertySelectionInput>
    export type SelectGoogleAnalyticsPropertyMutationError = ErrorType<void>

    /**
 * @summary Select the GA4 property to report on
 */
export const useSelectGoogleAnalyticsProperty = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof selectGoogleAnalyticsProperty>>, TError,{data: BodyType<GoogleAnalyticsPropertySelectionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof selectGoogleAnalyticsProperty>>,
        TError,
        {data: BodyType<GoogleAnalyticsPropertySelectionInput>},
        TContext
      > => {
      return useMutation(getSelectGoogleAnalyticsPropertyMutationOptions(options));
    }

export const getSelectGoogleSearchConsoleSiteUrl = () => {




  return `/api/owner/google-analytics/site`
}

/**
 * @summary Select the Search Console site to report on
 */
export const selectGoogleSearchConsoleSite = async (googleSearchConsoleSiteSelectionInput: GoogleSearchConsoleSiteSelectionInput, options?: Parameters<typeof customFetch>[1]): Promise<GoogleAnalyticsStatus> => {

  return customFetch<GoogleAnalyticsStatus>(getSelectGoogleSearchConsoleSiteUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(googleSearchConsoleSiteSelectionInput)
  }
);}





export const getSelectGoogleSearchConsoleSiteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof selectGoogleSearchConsoleSite>>, TError,{data: BodyType<GoogleSearchConsoleSiteSelectionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof selectGoogleSearchConsoleSite>>, TError,{data: BodyType<GoogleSearchConsoleSiteSelectionInput>}, TContext> => {

const mutationKey = ['selectGoogleSearchConsoleSite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof selectGoogleSearchConsoleSite>>, {data: BodyType<GoogleSearchConsoleSiteSelectionInput>}> = (props) => {
          const {data} = props ?? {};

          return  selectGoogleSearchConsoleSite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SelectGoogleSearchConsoleSiteMutationResult = NonNullable<Awaited<ReturnType<typeof selectGoogleSearchConsoleSite>>>
    export type SelectGoogleSearchConsoleSiteMutationBody = BodyType<GoogleSearchConsoleSiteSelectionInput>
    export type SelectGoogleSearchConsoleSiteMutationError = ErrorType<void>

    /**
 * @summary Select the Search Console site to report on
 */
export const useSelectGoogleSearchConsoleSite = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof selectGoogleSearchConsoleSite>>, TError,{data: BodyType<GoogleSearchConsoleSiteSelectionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof selectGoogleSearchConsoleSite>>,
        TError,
        {data: BodyType<GoogleSearchConsoleSiteSelectionInput>},
        TContext
      > => {
      return useMutation(getSelectGoogleSearchConsoleSiteMutationOptions(options));
    }

export const getGetGoogleAnalyticsInsightsReportUrl = (params: GetGoogleAnalyticsInsightsReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/owner/google-analytics/report?${stringifiedParams}` : `/api/owner/google-analytics/report`
}

/**
 * @summary Get bounded GA4 and Search Console reports
 */
export const getGoogleAnalyticsInsightsReport = async (params: GetGoogleAnalyticsInsightsReportParams, options?: Parameters<typeof customFetch>[1]): Promise<GoogleAnalyticsInsightsReport> => {

  return customFetch<GoogleAnalyticsInsightsReport>(getGetGoogleAnalyticsInsightsReportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGoogleAnalyticsInsightsReportQueryKey = (params?: GetGoogleAnalyticsInsightsReportParams,) => {
    return [
    `/api/owner/google-analytics/report`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetGoogleAnalyticsInsightsReportQueryOptions = <TData = Awaited<ReturnType<typeof getGoogleAnalyticsInsightsReport>>, TError = ErrorType<void>>(params: GetGoogleAnalyticsInsightsReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGoogleAnalyticsInsightsReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGoogleAnalyticsInsightsReportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGoogleAnalyticsInsightsReport>>> = ({ signal }) => getGoogleAnalyticsInsightsReport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGoogleAnalyticsInsightsReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGoogleAnalyticsInsightsReportQueryResult = NonNullable<Awaited<ReturnType<typeof getGoogleAnalyticsInsightsReport>>>
export type GetGoogleAnalyticsInsightsReportQueryError = ErrorType<void>


/**
 * @summary Get bounded GA4 and Search Console reports
 */

export function useGetGoogleAnalyticsInsightsReport<TData = Awaited<ReturnType<typeof getGoogleAnalyticsInsightsReport>>, TError = ErrorType<void>>(
 params: GetGoogleAnalyticsInsightsReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGoogleAnalyticsInsightsReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGoogleAnalyticsInsightsReportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDisconnectGoogleAnalyticsUrl = () => {




  return `/api/owner/google-analytics/disconnect`
}

/**
 * @summary Disconnect Google Analytics and Search Console reporting
 */
export const disconnectGoogleAnalytics = async ( options?: Parameters<typeof customFetch>[1]): Promise<DisconnectGoogleAnalytics200> => {

  return customFetch<DisconnectGoogleAnalytics200>(getDisconnectGoogleAnalyticsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDisconnectGoogleAnalyticsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectGoogleAnalytics>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectGoogleAnalytics>>, TError,void, TContext> => {

const mutationKey = ['disconnectGoogleAnalytics'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectGoogleAnalytics>>, void> = () => {


          return  disconnectGoogleAnalytics(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectGoogleAnalyticsMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectGoogleAnalytics>>>

    export type DisconnectGoogleAnalyticsMutationError = ErrorType<void>

    /**
 * @summary Disconnect Google Analytics and Search Console reporting
 */
export const useDisconnectGoogleAnalytics = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectGoogleAnalytics>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof disconnectGoogleAnalytics>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDisconnectGoogleAnalyticsMutationOptions(options));
    }

export const getSyncReviewInvitationsUrl = () => {




  return `/api/owner/reviews/sync`
}

/**
 * @summary Sync fulfilled purchases and send review invitations
 */
export const syncReviewInvitations = async ( options?: Parameters<typeof customFetch>[1]): Promise<ReviewInvitationSyncResponse> => {

  return customFetch<ReviewInvitationSyncResponse>(getSyncReviewInvitationsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSyncReviewInvitationsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncReviewInvitations>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncReviewInvitations>>, TError,void, TContext> => {

const mutationKey = ['syncReviewInvitations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncReviewInvitations>>, void> = () => {


          return  syncReviewInvitations(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncReviewInvitationsMutationResult = NonNullable<Awaited<ReturnType<typeof syncReviewInvitations>>>

    export type SyncReviewInvitationsMutationError = ErrorType<void>

    /**
 * @summary Sync fulfilled purchases and send review invitations
 */
export const useSyncReviewInvitations = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncReviewInvitations>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncReviewInvitations>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSyncReviewInvitationsMutationOptions(options));
    }

export const getGetAffiliateSessionUrl = () => {




  return `/api/affiliate/session`
}

/**
 * @summary Get the active affiliate account for the signed-in My Atelier phone
 */
export const getAffiliateSession = async ( options?: Parameters<typeof customFetch>[1]): Promise<AffiliateAccount> => {

  return customFetch<AffiliateAccount>(getGetAffiliateSessionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAffiliateSessionQueryKey = () => {
    return [
    `/api/affiliate/session`
    ] as const;
    }


export const getGetAffiliateSessionQueryOptions = <TData = Awaited<ReturnType<typeof getAffiliateSession>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAffiliateSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAffiliateSessionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAffiliateSession>>> = ({ signal }) => getAffiliateSession({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAffiliateSession>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAffiliateSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getAffiliateSession>>>
export type GetAffiliateSessionQueryError = ErrorType<void>


/**
 * @summary Get the active affiliate account for the signed-in My Atelier phone
 */

export function useGetAffiliateSession<TData = Awaited<ReturnType<typeof getAffiliateSession>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAffiliateSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAffiliateSessionQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAffiliateUsernameUrl = () => {




  return `/api/affiliate/username`
}

/**
 * @summary Set or change the affiliate username
 */
export const updateAffiliateUsername = async (affiliateUsernameInput: AffiliateUsernameInput, options?: Parameters<typeof customFetch>[1]): Promise<AffiliateAccount> => {

  return customFetch<AffiliateAccount>(getUpdateAffiliateUsernameUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(affiliateUsernameInput)
  }
);}





export const getUpdateAffiliateUsernameMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAffiliateUsername>>, TError,{data: BodyType<AffiliateUsernameInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAffiliateUsername>>, TError,{data: BodyType<AffiliateUsernameInput>}, TContext> => {

const mutationKey = ['updateAffiliateUsername'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAffiliateUsername>>, {data: BodyType<AffiliateUsernameInput>}> = (props) => {
          const {data} = props ?? {};

          return  updateAffiliateUsername(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAffiliateUsernameMutationResult = NonNullable<Awaited<ReturnType<typeof updateAffiliateUsername>>>
    export type UpdateAffiliateUsernameMutationBody = BodyType<AffiliateUsernameInput>
    export type UpdateAffiliateUsernameMutationError = ErrorType<void>

    /**
 * @summary Set or change the affiliate username
 */
export const useUpdateAffiliateUsername = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAffiliateUsername>>, TError,{data: BodyType<AffiliateUsernameInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAffiliateUsername>>,
        TError,
        {data: BodyType<AffiliateUsernameInput>},
        TContext
      > => {
      return useMutation(getUpdateAffiliateUsernameMutationOptions(options));
    }

export const getRecordAffiliateAttributionUrl = () => {




  return `/api/affiliate/attribution`
}

/**
 * @summary Record an affiliate link visit and set the attribution cookie
 */
export const recordAffiliateAttribution = async (affiliateAttributionInput: AffiliateAttributionInput, options?: Parameters<typeof customFetch>[1]): Promise<AffiliateAttributionResponse> => {

  return customFetch<AffiliateAttributionResponse>(getRecordAffiliateAttributionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(affiliateAttributionInput)
  }
);}





export const getRecordAffiliateAttributionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordAffiliateAttribution>>, TError,{data: BodyType<AffiliateAttributionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordAffiliateAttribution>>, TError,{data: BodyType<AffiliateAttributionInput>}, TContext> => {

const mutationKey = ['recordAffiliateAttribution'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordAffiliateAttribution>>, {data: BodyType<AffiliateAttributionInput>}> = (props) => {
          const {data} = props ?? {};

          return  recordAffiliateAttribution(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordAffiliateAttributionMutationResult = NonNullable<Awaited<ReturnType<typeof recordAffiliateAttribution>>>
    export type RecordAffiliateAttributionMutationBody = BodyType<AffiliateAttributionInput>
    export type RecordAffiliateAttributionMutationError = ErrorType<unknown>

    /**
 * @summary Record an affiliate link visit and set the attribution cookie
 */
export const useRecordAffiliateAttribution = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordAffiliateAttribution>>, TError,{data: BodyType<AffiliateAttributionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recordAffiliateAttribution>>,
        TError,
        {data: BodyType<AffiliateAttributionInput>},
        TContext
      > => {
      return useMutation(getRecordAffiliateAttributionMutationOptions(options));
    }

export const getListAffiliateSalesUrl = () => {




  return `/api/affiliate/sales`
}

/**
 * @summary List the signed-in affiliate's sales and payouts
 */
export const listAffiliateSales = async ( options?: Parameters<typeof customFetch>[1]): Promise<AffiliateSalesResponse> => {

  return customFetch<AffiliateSalesResponse>(getListAffiliateSalesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAffiliateSalesQueryKey = () => {
    return [
    `/api/affiliate/sales`
    ] as const;
    }


export const getListAffiliateSalesQueryOptions = <TData = Awaited<ReturnType<typeof listAffiliateSales>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAffiliateSales>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAffiliateSalesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAffiliateSales>>> = ({ signal }) => listAffiliateSales({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAffiliateSales>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAffiliateSalesQueryResult = NonNullable<Awaited<ReturnType<typeof listAffiliateSales>>>
export type ListAffiliateSalesQueryError = ErrorType<void>


/**
 * @summary List the signed-in affiliate's sales and payouts
 */

export function useListAffiliateSales<TData = Awaited<ReturnType<typeof listAffiliateSales>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAffiliateSales>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAffiliateSalesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRequestAffiliatePayoutUrl = () => {




  return `/api/affiliate/payouts`
}

/**
 * @summary Request payment of available affiliate commissions
 */
export const requestAffiliatePayout = async ( options?: Parameters<typeof customFetch>[1]): Promise<AffiliatePayout> => {

  return customFetch<AffiliatePayout>(getRequestAffiliatePayoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRequestAffiliatePayoutMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestAffiliatePayout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestAffiliatePayout>>, TError,void, TContext> => {

const mutationKey = ['requestAffiliatePayout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestAffiliatePayout>>, void> = () => {


          return  requestAffiliatePayout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestAffiliatePayoutMutationResult = NonNullable<Awaited<ReturnType<typeof requestAffiliatePayout>>>

    export type RequestAffiliatePayoutMutationError = ErrorType<void>

    /**
 * @summary Request payment of available affiliate commissions
 */
export const useRequestAffiliatePayout = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestAffiliatePayout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestAffiliatePayout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRequestAffiliatePayoutMutationOptions(options));
    }

export const getGetAffiliatePayoutDetailsUrl = () => {




  return `/api/affiliate/payout-details`
}

/**
 * @summary Get the signed-in affiliate's masked payout destination
 */
export const getAffiliatePayoutDetails = async ( options?: Parameters<typeof customFetch>[1]): Promise<AffiliatePayoutDetailsResponse> => {

  return customFetch<AffiliatePayoutDetailsResponse>(getGetAffiliatePayoutDetailsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAffiliatePayoutDetailsQueryKey = () => {
    return [
    `/api/affiliate/payout-details`
    ] as const;
    }


export const getGetAffiliatePayoutDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getAffiliatePayoutDetails>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAffiliatePayoutDetails>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAffiliatePayoutDetailsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAffiliatePayoutDetails>>> = ({ signal }) => getAffiliatePayoutDetails({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAffiliatePayoutDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAffiliatePayoutDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getAffiliatePayoutDetails>>>
export type GetAffiliatePayoutDetailsQueryError = ErrorType<void>


/**
 * @summary Get the signed-in affiliate's masked payout destination
 */

export function useGetAffiliatePayoutDetails<TData = Awaited<ReturnType<typeof getAffiliatePayoutDetails>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAffiliatePayoutDetails>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAffiliatePayoutDetailsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSaveAffiliatePayoutDetailsUrl = () => {




  return `/api/affiliate/payout-details`
}

/**
 * @summary Save a bank account or UPI destination for future payouts
 */
export const saveAffiliatePayoutDetails = async (affiliatePayoutDetailsUpdate: AffiliatePayoutDetailsUpdate, options?: Parameters<typeof customFetch>[1]): Promise<AffiliatePayoutDetailsResponse> => {

  return customFetch<AffiliatePayoutDetailsResponse>(getSaveAffiliatePayoutDetailsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(affiliatePayoutDetailsUpdate)
  }
);}





export const getSaveAffiliatePayoutDetailsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAffiliatePayoutDetails>>, TError,{data: BodyType<AffiliatePayoutDetailsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveAffiliatePayoutDetails>>, TError,{data: BodyType<AffiliatePayoutDetailsUpdate>}, TContext> => {

const mutationKey = ['saveAffiliatePayoutDetails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveAffiliatePayoutDetails>>, {data: BodyType<AffiliatePayoutDetailsUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  saveAffiliatePayoutDetails(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveAffiliatePayoutDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof saveAffiliatePayoutDetails>>>
    export type SaveAffiliatePayoutDetailsMutationBody = BodyType<AffiliatePayoutDetailsUpdate>
    export type SaveAffiliatePayoutDetailsMutationError = ErrorType<void>

    /**
 * @summary Save a bank account or UPI destination for future payouts
 */
export const useSaveAffiliatePayoutDetails = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAffiliatePayoutDetails>>, TError,{data: BodyType<AffiliatePayoutDetailsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveAffiliatePayoutDetails>>,
        TError,
        {data: BodyType<AffiliatePayoutDetailsUpdate>},
        TContext
      > => {
      return useMutation(getSaveAffiliatePayoutDetailsMutationOptions(options));
    }

export const getCreateAffiliateApplicationUrl = () => {




  return `/api/affiliate/applications`
}

/**
 * @summary Submit a public affiliate application
 */
export const createAffiliateApplication = async (affiliateApplicationInput: AffiliateApplicationInput, options?: Parameters<typeof customFetch>[1]): Promise<AffiliateApplicationSubmission> => {

  return customFetch<AffiliateApplicationSubmission>(getCreateAffiliateApplicationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(affiliateApplicationInput)
  }
);}





export const getCreateAffiliateApplicationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAffiliateApplication>>, TError,{data: BodyType<AffiliateApplicationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAffiliateApplication>>, TError,{data: BodyType<AffiliateApplicationInput>}, TContext> => {

const mutationKey = ['createAffiliateApplication'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAffiliateApplication>>, {data: BodyType<AffiliateApplicationInput>}> = (props) => {
          const {data} = props ?? {};

          return  createAffiliateApplication(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAffiliateApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof createAffiliateApplication>>>
    export type CreateAffiliateApplicationMutationBody = BodyType<AffiliateApplicationInput>
    export type CreateAffiliateApplicationMutationError = ErrorType<void>

    /**
 * @summary Submit a public affiliate application
 */
export const useCreateAffiliateApplication = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAffiliateApplication>>, TError,{data: BodyType<AffiliateApplicationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAffiliateApplication>>,
        TError,
        {data: BodyType<AffiliateApplicationInput>},
        TContext
      > => {
      return useMutation(getCreateAffiliateApplicationMutationOptions(options));
    }

export const getGetOwnerAffiliateCommissionDefaultUrl = () => {




  return `/api/owner/affiliate-commission-default`
}

/**
 * @summary Get the default affiliate commission schedule
 */
export const getOwnerAffiliateCommissionDefault = async ( options?: Parameters<typeof customFetch>[1]): Promise<OwnerAffiliateCommissionDefault> => {

  return customFetch<OwnerAffiliateCommissionDefault>(getGetOwnerAffiliateCommissionDefaultUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOwnerAffiliateCommissionDefaultQueryKey = () => {
    return [
    `/api/owner/affiliate-commission-default`
    ] as const;
    }


export const getGetOwnerAffiliateCommissionDefaultQueryOptions = <TData = Awaited<ReturnType<typeof getOwnerAffiliateCommissionDefault>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOwnerAffiliateCommissionDefault>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnerAffiliateCommissionDefaultQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwnerAffiliateCommissionDefault>>> = ({ signal }) => getOwnerAffiliateCommissionDefault({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOwnerAffiliateCommissionDefault>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOwnerAffiliateCommissionDefaultQueryResult = NonNullable<Awaited<ReturnType<typeof getOwnerAffiliateCommissionDefault>>>
export type GetOwnerAffiliateCommissionDefaultQueryError = ErrorType<void>


/**
 * @summary Get the default affiliate commission schedule
 */

export function useGetOwnerAffiliateCommissionDefault<TData = Awaited<ReturnType<typeof getOwnerAffiliateCommissionDefault>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOwnerAffiliateCommissionDefault>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOwnerAffiliateCommissionDefaultQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateOwnerAffiliateCommissionDefaultUrl = () => {




  return `/api/owner/affiliate-commission-default`
}

/**
 * @summary Set the default affiliate commission schedule
 */
export const updateOwnerAffiliateCommissionDefault = async (ownerAffiliateCommissionDefaultInput: OwnerAffiliateCommissionDefaultInput, options?: Parameters<typeof customFetch>[1]): Promise<OwnerAffiliateCommissionDefault> => {

  return customFetch<OwnerAffiliateCommissionDefault>(getUpdateOwnerAffiliateCommissionDefaultUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerAffiliateCommissionDefaultInput)
  }
);}





export const getUpdateOwnerAffiliateCommissionDefaultMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAffiliateCommissionDefault>>, TError,{data: BodyType<OwnerAffiliateCommissionDefaultInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAffiliateCommissionDefault>>, TError,{data: BodyType<OwnerAffiliateCommissionDefaultInput>}, TContext> => {

const mutationKey = ['updateOwnerAffiliateCommissionDefault'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOwnerAffiliateCommissionDefault>>, {data: BodyType<OwnerAffiliateCommissionDefaultInput>}> = (props) => {
          const {data} = props ?? {};

          return  updateOwnerAffiliateCommissionDefault(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOwnerAffiliateCommissionDefaultMutationResult = NonNullable<Awaited<ReturnType<typeof updateOwnerAffiliateCommissionDefault>>>
    export type UpdateOwnerAffiliateCommissionDefaultMutationBody = BodyType<OwnerAffiliateCommissionDefaultInput>
    export type UpdateOwnerAffiliateCommissionDefaultMutationError = ErrorType<void>

    /**
 * @summary Set the default affiliate commission schedule
 */
export const useUpdateOwnerAffiliateCommissionDefault = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAffiliateCommissionDefault>>, TError,{data: BodyType<OwnerAffiliateCommissionDefaultInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOwnerAffiliateCommissionDefault>>,
        TError,
        {data: BodyType<OwnerAffiliateCommissionDefaultInput>},
        TContext
      > => {
      return useMutation(getUpdateOwnerAffiliateCommissionDefaultMutationOptions(options));
    }

export const getListOwnerAffiliatesUrl = () => {




  return `/api/owner/affiliates`
}

/**
 * @summary List affiliate accounts for the owner
 */
export const listOwnerAffiliates = async ( options?: Parameters<typeof customFetch>[1]): Promise<OwnerAffiliate[]> => {

  return customFetch<OwnerAffiliate[]>(getListOwnerAffiliatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOwnerAffiliatesQueryKey = () => {
    return [
    `/api/owner/affiliates`
    ] as const;
    }


export const getListOwnerAffiliatesQueryOptions = <TData = Awaited<ReturnType<typeof listOwnerAffiliates>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOwnerAffiliates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOwnerAffiliatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOwnerAffiliates>>> = ({ signal }) => listOwnerAffiliates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOwnerAffiliates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOwnerAffiliatesQueryResult = NonNullable<Awaited<ReturnType<typeof listOwnerAffiliates>>>
export type ListOwnerAffiliatesQueryError = ErrorType<void>


/**
 * @summary List affiliate accounts for the owner
 */

export function useListOwnerAffiliates<TData = Awaited<ReturnType<typeof listOwnerAffiliates>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOwnerAffiliates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOwnerAffiliatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateOwnerAffiliateUrl = () => {




  return `/api/owner/affiliates`
}

/**
 * @summary Create an affiliate account
 */
export const createOwnerAffiliate = async (ownerAffiliateCreate: OwnerAffiliateCreate, options?: Parameters<typeof customFetch>[1]): Promise<OwnerAffiliateCreationResult> => {

  return customFetch<OwnerAffiliateCreationResult>(getCreateOwnerAffiliateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerAffiliateCreate)
  }
);}





export const getCreateOwnerAffiliateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOwnerAffiliate>>, TError,{data: BodyType<OwnerAffiliateCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOwnerAffiliate>>, TError,{data: BodyType<OwnerAffiliateCreate>}, TContext> => {

const mutationKey = ['createOwnerAffiliate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOwnerAffiliate>>, {data: BodyType<OwnerAffiliateCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createOwnerAffiliate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOwnerAffiliateMutationResult = NonNullable<Awaited<ReturnType<typeof createOwnerAffiliate>>>
    export type CreateOwnerAffiliateMutationBody = BodyType<OwnerAffiliateCreate>
    export type CreateOwnerAffiliateMutationError = ErrorType<void>

    /**
 * @summary Create an affiliate account
 */
export const useCreateOwnerAffiliate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOwnerAffiliate>>, TError,{data: BodyType<OwnerAffiliateCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOwnerAffiliate>>,
        TError,
        {data: BodyType<OwnerAffiliateCreate>},
        TContext
      > => {
      return useMutation(getCreateOwnerAffiliateMutationOptions(options));
    }

export const getListOwnerAffiliateApplicationsUrl = () => {




  return `/api/owner/affiliate-applications`
}

/**
 * @summary List pending affiliate applications for the owner
 */
export const listOwnerAffiliateApplications = async ( options?: Parameters<typeof customFetch>[1]): Promise<OwnerAffiliateApplication[]> => {

  return customFetch<OwnerAffiliateApplication[]>(getListOwnerAffiliateApplicationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOwnerAffiliateApplicationsQueryKey = () => {
    return [
    `/api/owner/affiliate-applications`
    ] as const;
    }


export const getListOwnerAffiliateApplicationsQueryOptions = <TData = Awaited<ReturnType<typeof listOwnerAffiliateApplications>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOwnerAffiliateApplications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOwnerAffiliateApplicationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOwnerAffiliateApplications>>> = ({ signal }) => listOwnerAffiliateApplications({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOwnerAffiliateApplications>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOwnerAffiliateApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof listOwnerAffiliateApplications>>>
export type ListOwnerAffiliateApplicationsQueryError = ErrorType<void>


/**
 * @summary List pending affiliate applications for the owner
 */

export function useListOwnerAffiliateApplications<TData = Awaited<ReturnType<typeof listOwnerAffiliateApplications>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOwnerAffiliateApplications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOwnerAffiliateApplicationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getApproveOwnerAffiliateApplicationUrl = () => {




  return `/api/owner/affiliate-applications/approve`
}

/**
 * @summary Confirm an affiliate commission schedule and activate the applicant
 */
export const approveOwnerAffiliateApplication = async (ownerAffiliateApplicationApprovalInput: OwnerAffiliateApplicationApprovalInput, options?: Parameters<typeof customFetch>[1]): Promise<OwnerAffiliateCreationResult> => {

  return customFetch<OwnerAffiliateCreationResult>(getApproveOwnerAffiliateApplicationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerAffiliateApplicationApprovalInput)
  }
);}





export const getApproveOwnerAffiliateApplicationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveOwnerAffiliateApplication>>, TError,{data: BodyType<OwnerAffiliateApplicationApprovalInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveOwnerAffiliateApplication>>, TError,{data: BodyType<OwnerAffiliateApplicationApprovalInput>}, TContext> => {

const mutationKey = ['approveOwnerAffiliateApplication'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveOwnerAffiliateApplication>>, {data: BodyType<OwnerAffiliateApplicationApprovalInput>}> = (props) => {
          const {data} = props ?? {};

          return  approveOwnerAffiliateApplication(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveOwnerAffiliateApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof approveOwnerAffiliateApplication>>>
    export type ApproveOwnerAffiliateApplicationMutationBody = BodyType<OwnerAffiliateApplicationApprovalInput>
    export type ApproveOwnerAffiliateApplicationMutationError = ErrorType<void>

    /**
 * @summary Confirm an affiliate commission schedule and activate the applicant
 */
export const useApproveOwnerAffiliateApplication = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveOwnerAffiliateApplication>>, TError,{data: BodyType<OwnerAffiliateApplicationApprovalInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveOwnerAffiliateApplication>>,
        TError,
        {data: BodyType<OwnerAffiliateApplicationApprovalInput>},
        TContext
      > => {
      return useMutation(getApproveOwnerAffiliateApplicationMutationOptions(options));
    }

export const getRetryOwnerAffiliateApplicationNotificationUrl = () => {




  return `/api/owner/affiliate-applications/retry-notification`
}

/**
 * @summary Retry the email alert for a pending affiliate application
 */
export const retryOwnerAffiliateApplicationNotification = async (ownerAffiliateApplicationNotificationInput: OwnerAffiliateApplicationNotificationInput, options?: Parameters<typeof customFetch>[1]): Promise<OwnerAffiliateApplicationNotificationResult> => {

  return customFetch<OwnerAffiliateApplicationNotificationResult>(getRetryOwnerAffiliateApplicationNotificationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerAffiliateApplicationNotificationInput)
  }
);}





export const getRetryOwnerAffiliateApplicationNotificationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryOwnerAffiliateApplicationNotification>>, TError,{data: BodyType<OwnerAffiliateApplicationNotificationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryOwnerAffiliateApplicationNotification>>, TError,{data: BodyType<OwnerAffiliateApplicationNotificationInput>}, TContext> => {

const mutationKey = ['retryOwnerAffiliateApplicationNotification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryOwnerAffiliateApplicationNotification>>, {data: BodyType<OwnerAffiliateApplicationNotificationInput>}> = (props) => {
          const {data} = props ?? {};

          return  retryOwnerAffiliateApplicationNotification(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryOwnerAffiliateApplicationNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof retryOwnerAffiliateApplicationNotification>>>
    export type RetryOwnerAffiliateApplicationNotificationMutationBody = BodyType<OwnerAffiliateApplicationNotificationInput>
    export type RetryOwnerAffiliateApplicationNotificationMutationError = ErrorType<void>

    /**
 * @summary Retry the email alert for a pending affiliate application
 */
export const useRetryOwnerAffiliateApplicationNotification = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryOwnerAffiliateApplicationNotification>>, TError,{data: BodyType<OwnerAffiliateApplicationNotificationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof retryOwnerAffiliateApplicationNotification>>,
        TError,
        {data: BodyType<OwnerAffiliateApplicationNotificationInput>},
        TContext
      > => {
      return useMutation(getRetryOwnerAffiliateApplicationNotificationMutationOptions(options));
    }

export const getUpdateOwnerAffiliateUrl = () => {




  return `/api/owner/affiliates/update`
}

/**
 * @summary Update affiliate details, commission schedule, or active status
 */
export const updateOwnerAffiliate = async (ownerAffiliateUpdate: OwnerAffiliateUpdate, options?: Parameters<typeof customFetch>[1]): Promise<OwnerAffiliate> => {

  return customFetch<OwnerAffiliate>(getUpdateOwnerAffiliateUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerAffiliateUpdate)
  }
);}





export const getUpdateOwnerAffiliateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAffiliate>>, TError,{data: BodyType<OwnerAffiliateUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAffiliate>>, TError,{data: BodyType<OwnerAffiliateUpdate>}, TContext> => {

const mutationKey = ['updateOwnerAffiliate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOwnerAffiliate>>, {data: BodyType<OwnerAffiliateUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateOwnerAffiliate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOwnerAffiliateMutationResult = NonNullable<Awaited<ReturnType<typeof updateOwnerAffiliate>>>
    export type UpdateOwnerAffiliateMutationBody = BodyType<OwnerAffiliateUpdate>
    export type UpdateOwnerAffiliateMutationError = ErrorType<void>

    /**
 * @summary Update affiliate details, commission schedule, or active status
 */
export const useUpdateOwnerAffiliate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAffiliate>>, TError,{data: BodyType<OwnerAffiliateUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOwnerAffiliate>>,
        TError,
        {data: BodyType<OwnerAffiliateUpdate>},
        TContext
      > => {
      return useMutation(getUpdateOwnerAffiliateMutationOptions(options));
    }

export const getListOwnerAffiliateSalesUrl = () => {




  return `/api/owner/affiliate-sales`
}

/**
 * @summary List recent affiliate sales and claim holds
 */
export const listOwnerAffiliateSales = async ( options?: Parameters<typeof customFetch>[1]): Promise<OwnerAffiliateSale[]> => {

  return customFetch<OwnerAffiliateSale[]>(getListOwnerAffiliateSalesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOwnerAffiliateSalesQueryKey = () => {
    return [
    `/api/owner/affiliate-sales`
    ] as const;
    }


export const getListOwnerAffiliateSalesQueryOptions = <TData = Awaited<ReturnType<typeof listOwnerAffiliateSales>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOwnerAffiliateSales>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOwnerAffiliateSalesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOwnerAffiliateSales>>> = ({ signal }) => listOwnerAffiliateSales({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOwnerAffiliateSales>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOwnerAffiliateSalesQueryResult = NonNullable<Awaited<ReturnType<typeof listOwnerAffiliateSales>>>
export type ListOwnerAffiliateSalesQueryError = ErrorType<void>


/**
 * @summary List recent affiliate sales and claim holds
 */

export function useListOwnerAffiliateSales<TData = Awaited<ReturnType<typeof listOwnerAffiliateSales>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOwnerAffiliateSales>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOwnerAffiliateSalesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateOwnerAffiliateSaleHoldUrl = () => {




  return `/api/owner/affiliate-sales`
}

/**
 * @summary Hold or release commission while a customer claim is reviewed
 */
export const updateOwnerAffiliateSaleHold = async (ownerAffiliateSaleHold: OwnerAffiliateSaleHold, options?: Parameters<typeof customFetch>[1]): Promise<OwnerAffiliateSale> => {

  return customFetch<OwnerAffiliateSale>(getUpdateOwnerAffiliateSaleHoldUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerAffiliateSaleHold)
  }
);}





export const getUpdateOwnerAffiliateSaleHoldMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAffiliateSaleHold>>, TError,{data: BodyType<OwnerAffiliateSaleHold>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAffiliateSaleHold>>, TError,{data: BodyType<OwnerAffiliateSaleHold>}, TContext> => {

const mutationKey = ['updateOwnerAffiliateSaleHold'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOwnerAffiliateSaleHold>>, {data: BodyType<OwnerAffiliateSaleHold>}> = (props) => {
          const {data} = props ?? {};

          return  updateOwnerAffiliateSaleHold(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOwnerAffiliateSaleHoldMutationResult = NonNullable<Awaited<ReturnType<typeof updateOwnerAffiliateSaleHold>>>
    export type UpdateOwnerAffiliateSaleHoldMutationBody = BodyType<OwnerAffiliateSaleHold>
    export type UpdateOwnerAffiliateSaleHoldMutationError = ErrorType<void>

    /**
 * @summary Hold or release commission while a customer claim is reviewed
 */
export const useUpdateOwnerAffiliateSaleHold = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAffiliateSaleHold>>, TError,{data: BodyType<OwnerAffiliateSaleHold>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOwnerAffiliateSaleHold>>,
        TError,
        {data: BodyType<OwnerAffiliateSaleHold>},
        TContext
      > => {
      return useMutation(getUpdateOwnerAffiliateSaleHoldMutationOptions(options));
    }

export const getListOwnerAffiliatePayoutsUrl = () => {




  return `/api/owner/affiliate-payouts`
}

/**
 * @summary List affiliate payout requests
 */
export const listOwnerAffiliatePayouts = async ( options?: Parameters<typeof customFetch>[1]): Promise<OwnerAffiliatePayout[]> => {

  return customFetch<OwnerAffiliatePayout[]>(getListOwnerAffiliatePayoutsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOwnerAffiliatePayoutsQueryKey = () => {
    return [
    `/api/owner/affiliate-payouts`
    ] as const;
    }


export const getListOwnerAffiliatePayoutsQueryOptions = <TData = Awaited<ReturnType<typeof listOwnerAffiliatePayouts>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOwnerAffiliatePayouts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOwnerAffiliatePayoutsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOwnerAffiliatePayouts>>> = ({ signal }) => listOwnerAffiliatePayouts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOwnerAffiliatePayouts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOwnerAffiliatePayoutsQueryResult = NonNullable<Awaited<ReturnType<typeof listOwnerAffiliatePayouts>>>
export type ListOwnerAffiliatePayoutsQueryError = ErrorType<void>


/**
 * @summary List affiliate payout requests
 */

export function useListOwnerAffiliatePayouts<TData = Awaited<ReturnType<typeof listOwnerAffiliatePayouts>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOwnerAffiliatePayouts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOwnerAffiliatePayoutsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateOwnerAffiliatePayoutUrl = () => {




  return `/api/owner/affiliate-payouts`
}

/**
 * @summary Record an offline payout or reject a request
 */
export const updateOwnerAffiliatePayout = async (ownerAffiliatePayoutUpdate: OwnerAffiliatePayoutUpdate, options?: Parameters<typeof customFetch>[1]): Promise<OwnerAffiliatePayout> => {

  return customFetch<OwnerAffiliatePayout>(getUpdateOwnerAffiliatePayoutUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerAffiliatePayoutUpdate)
  }
);}





export const getUpdateOwnerAffiliatePayoutMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAffiliatePayout>>, TError,{data: BodyType<OwnerAffiliatePayoutUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAffiliatePayout>>, TError,{data: BodyType<OwnerAffiliatePayoutUpdate>}, TContext> => {

const mutationKey = ['updateOwnerAffiliatePayout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOwnerAffiliatePayout>>, {data: BodyType<OwnerAffiliatePayoutUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateOwnerAffiliatePayout(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOwnerAffiliatePayoutMutationResult = NonNullable<Awaited<ReturnType<typeof updateOwnerAffiliatePayout>>>
    export type UpdateOwnerAffiliatePayoutMutationBody = BodyType<OwnerAffiliatePayoutUpdate>
    export type UpdateOwnerAffiliatePayoutMutationError = ErrorType<void>

    /**
 * @summary Record an offline payout or reject a request
 */
export const useUpdateOwnerAffiliatePayout = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOwnerAffiliatePayout>>, TError,{data: BodyType<OwnerAffiliatePayoutUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOwnerAffiliatePayout>>,
        TError,
        {data: BodyType<OwnerAffiliatePayoutUpdate>},
        TContext
      > => {
      return useMutation(getUpdateOwnerAffiliatePayoutMutationOptions(options));
    }

export const getGetOwnerMarketingAudienceUrl = () => {




  return `/api/owner/marketing/audience`
}

/**
 * @summary Get eligible Shopify customer counts for marketing
 */
export const getOwnerMarketingAudience = async ( options?: Parameters<typeof customFetch>[1]): Promise<OwnerMarketingAudience> => {

  return customFetch<OwnerMarketingAudience>(getGetOwnerMarketingAudienceUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOwnerMarketingAudienceQueryKey = () => {
    return [
    `/api/owner/marketing/audience`
    ] as const;
    }


export const getGetOwnerMarketingAudienceQueryOptions = <TData = Awaited<ReturnType<typeof getOwnerMarketingAudience>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOwnerMarketingAudience>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnerMarketingAudienceQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwnerMarketingAudience>>> = ({ signal }) => getOwnerMarketingAudience({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOwnerMarketingAudience>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOwnerMarketingAudienceQueryResult = NonNullable<Awaited<ReturnType<typeof getOwnerMarketingAudience>>>
export type GetOwnerMarketingAudienceQueryError = ErrorType<void>


/**
 * @summary Get eligible Shopify customer counts for marketing
 */

export function useGetOwnerMarketingAudience<TData = Awaited<ReturnType<typeof getOwnerMarketingAudience>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOwnerMarketingAudience>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOwnerMarketingAudienceQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListOwnerMarketingWhatsAppTemplatesUrl = () => {




  return `/api/owner/marketing/whatsapp-templates`
}

/**
 * @summary List WhatsApp marketing templates and approval statuses
 */
export const listOwnerMarketingWhatsAppTemplates = async ( options?: Parameters<typeof customFetch>[1]): Promise<OwnerMarketingWhatsAppTemplate[]> => {

  return customFetch<OwnerMarketingWhatsAppTemplate[]>(getListOwnerMarketingWhatsAppTemplatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOwnerMarketingWhatsAppTemplatesQueryKey = () => {
    return [
    `/api/owner/marketing/whatsapp-templates`
    ] as const;
    }


export const getListOwnerMarketingWhatsAppTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listOwnerMarketingWhatsAppTemplates>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOwnerMarketingWhatsAppTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOwnerMarketingWhatsAppTemplatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOwnerMarketingWhatsAppTemplates>>> = ({ signal }) => listOwnerMarketingWhatsAppTemplates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOwnerMarketingWhatsAppTemplates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOwnerMarketingWhatsAppTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listOwnerMarketingWhatsAppTemplates>>>
export type ListOwnerMarketingWhatsAppTemplatesQueryError = ErrorType<void>


/**
 * @summary List WhatsApp marketing templates and approval statuses
 */

export function useListOwnerMarketingWhatsAppTemplates<TData = Awaited<ReturnType<typeof listOwnerMarketingWhatsAppTemplates>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOwnerMarketingWhatsAppTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOwnerMarketingWhatsAppTemplatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateOwnerMarketingWhatsAppTemplateUrl = () => {




  return `/api/owner/marketing/whatsapp-templates`
}

/**
 * @summary Submit a WhatsApp marketing template for review
 */
export const createOwnerMarketingWhatsAppTemplate = async (ownerMarketingWhatsAppTemplateInput: OwnerMarketingWhatsAppTemplateInput, options?: Parameters<typeof customFetch>[1]): Promise<OwnerMarketingWhatsAppTemplate> => {

  return customFetch<OwnerMarketingWhatsAppTemplate>(getCreateOwnerMarketingWhatsAppTemplateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerMarketingWhatsAppTemplateInput)
  }
);}





export const getCreateOwnerMarketingWhatsAppTemplateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOwnerMarketingWhatsAppTemplate>>, TError,{data: BodyType<OwnerMarketingWhatsAppTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOwnerMarketingWhatsAppTemplate>>, TError,{data: BodyType<OwnerMarketingWhatsAppTemplateInput>}, TContext> => {

const mutationKey = ['createOwnerMarketingWhatsAppTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOwnerMarketingWhatsAppTemplate>>, {data: BodyType<OwnerMarketingWhatsAppTemplateInput>}> = (props) => {
          const {data} = props ?? {};

          return  createOwnerMarketingWhatsAppTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOwnerMarketingWhatsAppTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createOwnerMarketingWhatsAppTemplate>>>
    export type CreateOwnerMarketingWhatsAppTemplateMutationBody = BodyType<OwnerMarketingWhatsAppTemplateInput>
    export type CreateOwnerMarketingWhatsAppTemplateMutationError = ErrorType<void>

    /**
 * @summary Submit a WhatsApp marketing template for review
 */
export const useCreateOwnerMarketingWhatsAppTemplate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOwnerMarketingWhatsAppTemplate>>, TError,{data: BodyType<OwnerMarketingWhatsAppTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOwnerMarketingWhatsAppTemplate>>,
        TError,
        {data: BodyType<OwnerMarketingWhatsAppTemplateInput>},
        TContext
      > => {
      return useMutation(getCreateOwnerMarketingWhatsAppTemplateMutationOptions(options));
    }

export const getListOwnerMarketingCampaignsUrl = () => {




  return `/api/owner/marketing/campaigns`
}

/**
 * @summary List recent marketing campaigns
 */
export const listOwnerMarketingCampaigns = async ( options?: Parameters<typeof customFetch>[1]): Promise<OwnerMarketingCampaignList> => {

  return customFetch<OwnerMarketingCampaignList>(getListOwnerMarketingCampaignsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOwnerMarketingCampaignsQueryKey = () => {
    return [
    `/api/owner/marketing/campaigns`
    ] as const;
    }


export const getListOwnerMarketingCampaignsQueryOptions = <TData = Awaited<ReturnType<typeof listOwnerMarketingCampaigns>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOwnerMarketingCampaigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOwnerMarketingCampaignsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOwnerMarketingCampaigns>>> = ({ signal }) => listOwnerMarketingCampaigns({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOwnerMarketingCampaigns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOwnerMarketingCampaignsQueryResult = NonNullable<Awaited<ReturnType<typeof listOwnerMarketingCampaigns>>>
export type ListOwnerMarketingCampaignsQueryError = ErrorType<void>


/**
 * @summary List recent marketing campaigns
 */

export function useListOwnerMarketingCampaigns<TData = Awaited<ReturnType<typeof listOwnerMarketingCampaigns>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOwnerMarketingCampaigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOwnerMarketingCampaignsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateOwnerMarketingCampaignUrl = () => {




  return `/api/owner/marketing/campaigns`
}

/**
 * @summary Save a marketing campaign draft
 */
export const createOwnerMarketingCampaign = async (ownerMarketingCampaignCreate: OwnerMarketingCampaignCreate, options?: Parameters<typeof customFetch>[1]): Promise<OwnerMarketingCampaign> => {

  return customFetch<OwnerMarketingCampaign>(getCreateOwnerMarketingCampaignUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerMarketingCampaignCreate)
  }
);}





export const getCreateOwnerMarketingCampaignMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOwnerMarketingCampaign>>, TError,{data: BodyType<OwnerMarketingCampaignCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOwnerMarketingCampaign>>, TError,{data: BodyType<OwnerMarketingCampaignCreate>}, TContext> => {

const mutationKey = ['createOwnerMarketingCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOwnerMarketingCampaign>>, {data: BodyType<OwnerMarketingCampaignCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createOwnerMarketingCampaign(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOwnerMarketingCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof createOwnerMarketingCampaign>>>
    export type CreateOwnerMarketingCampaignMutationBody = BodyType<OwnerMarketingCampaignCreate>
    export type CreateOwnerMarketingCampaignMutationError = ErrorType<void>

    /**
 * @summary Save a marketing campaign draft
 */
export const useCreateOwnerMarketingCampaign = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOwnerMarketingCampaign>>, TError,{data: BodyType<OwnerMarketingCampaignCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOwnerMarketingCampaign>>,
        TError,
        {data: BodyType<OwnerMarketingCampaignCreate>},
        TContext
      > => {
      return useMutation(getCreateOwnerMarketingCampaignMutationOptions(options));
    }

export const getSendOwnerMarketingCampaignUrl = (campaignId: string,) => {




  return `/api/owner/marketing/campaigns/${campaignId}/send`
}

/**
 * @summary Queue a campaign after explicit owner confirmation
 */
export const sendOwnerMarketingCampaign = async (campaignId: string,
    ownerMarketingCampaignSendInput: OwnerMarketingCampaignSendInput, options?: Parameters<typeof customFetch>[1]): Promise<OwnerMarketingCampaignSendResult> => {

  return customFetch<OwnerMarketingCampaignSendResult>(getSendOwnerMarketingCampaignUrl(campaignId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ownerMarketingCampaignSendInput)
  }
);}





export const getSendOwnerMarketingCampaignMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendOwnerMarketingCampaign>>, TError,{campaignId: string;data: BodyType<OwnerMarketingCampaignSendInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendOwnerMarketingCampaign>>, TError,{campaignId: string;data: BodyType<OwnerMarketingCampaignSendInput>}, TContext> => {

const mutationKey = ['sendOwnerMarketingCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendOwnerMarketingCampaign>>, {campaignId: string;data: BodyType<OwnerMarketingCampaignSendInput>}> = (props) => {
          const {campaignId,data} = props ?? {};

          return  sendOwnerMarketingCampaign(campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendOwnerMarketingCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof sendOwnerMarketingCampaign>>>
    export type SendOwnerMarketingCampaignMutationBody = BodyType<OwnerMarketingCampaignSendInput>
    export type SendOwnerMarketingCampaignMutationError = ErrorType<void>

    /**
 * @summary Queue a campaign after explicit owner confirmation
 */
export const useSendOwnerMarketingCampaign = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendOwnerMarketingCampaign>>, TError,{campaignId: string;data: BodyType<OwnerMarketingCampaignSendInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendOwnerMarketingCampaign>>,
        TError,
        {campaignId: string;data: BodyType<OwnerMarketingCampaignSendInput>},
        TContext
      > => {
      return useMutation(getSendOwnerMarketingCampaignMutationOptions(options));
    }

export const getPauseOwnerMarketingCampaignUrl = (campaignId: string,) => {




  return `/api/owner/marketing/campaigns/${campaignId}/pause`
}

/**
 * @summary Pause a queued or sending campaign
 */
export const pauseOwnerMarketingCampaign = async (campaignId: string, options?: Parameters<typeof customFetch>[1]): Promise<OwnerMarketingCampaign> => {

  return customFetch<OwnerMarketingCampaign>(getPauseOwnerMarketingCampaignUrl(campaignId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPauseOwnerMarketingCampaignMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseOwnerMarketingCampaign>>, TError,{campaignId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pauseOwnerMarketingCampaign>>, TError,{campaignId: string}, TContext> => {

const mutationKey = ['pauseOwnerMarketingCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pauseOwnerMarketingCampaign>>, {campaignId: string}> = (props) => {
          const {campaignId} = props ?? {};

          return  pauseOwnerMarketingCampaign(campaignId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PauseOwnerMarketingCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof pauseOwnerMarketingCampaign>>>

    export type PauseOwnerMarketingCampaignMutationError = ErrorType<void>

    /**
 * @summary Pause a queued or sending campaign
 */
export const usePauseOwnerMarketingCampaign = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseOwnerMarketingCampaign>>, TError,{campaignId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pauseOwnerMarketingCampaign>>,
        TError,
        {campaignId: string},
        TContext
      > => {
      return useMutation(getPauseOwnerMarketingCampaignMutationOptions(options));
    }

